import { Utility, FileModel, ServiceProvider, AthenaeumConstants, BaseLocalizer } from '@renta-apps/athenaeum-toolkit';
import React from 'react';
import { Dictionary } from 'typescript-collections';
import { Mutex } from 'async-mutex';
import queryString from 'query-string';
import $$h from 'jquery';

var WebApplicationType;
(function (WebApplicationType) {
  WebApplicationType[WebApplicationType["DesktopBrowser"] = 0] = "DesktopBrowser";
  WebApplicationType[WebApplicationType["MobileBrowser"] = 1] = "MobileBrowser";
  WebApplicationType[WebApplicationType["MobileApp"] = 2] = "MobileApp";
  WebApplicationType[WebApplicationType["PwaApp"] = 3] = "PwaApp";
})(WebApplicationType || (WebApplicationType = {}));
var Align;
(function (Align) {
  Align[Align["Bottom"] = 0] = "Bottom";
  Align[Align["Top"] = 1] = "Top";
})(Align || (Align = {}));
var Justify;
(function (Justify) {
  Justify[Justify["Left"] = 0] = "Left";
  Justify[Justify["Right"] = 1] = "Right";
})(Justify || (Justify = {}));
var TextAlign;
(function (TextAlign) {
  TextAlign[TextAlign["Left"] = 0] = "Left";
  TextAlign[TextAlign["Center"] = 1] = "Center";
  TextAlign[TextAlign["Right"] = 2] = "Right";
})(TextAlign || (TextAlign = {}));
var VerticalAlign;
(function (VerticalAlign) {
  VerticalAlign[VerticalAlign["Top"] = 0] = "Top";
  VerticalAlign[VerticalAlign["Middle"] = 1] = "Middle";
  VerticalAlign[VerticalAlign["Bottom"] = 2] = "Bottom";
})(VerticalAlign || (VerticalAlign = {}));
var AlertType;
(function (AlertType) {
  AlertType[AlertType["Success"] = 0] = "Success";
  AlertType[AlertType["Warning"] = 1] = "Warning";
  AlertType[AlertType["Info"] = 2] = "Info";
  AlertType[AlertType["Danger"] = 3] = "Danger";
  AlertType[AlertType["Primary"] = 4] = "Primary";
  AlertType[AlertType["Secondary"] = 5] = "Secondary";
  AlertType[AlertType["Light"] = 6] = "Light";
  AlertType[AlertType["Dark"] = 7] = "Dark";
})(AlertType || (AlertType = {}));
/**
 * Specifies identifiers to indicate the return value of a dialog box.
 */
var DialogResult;
(function (DialogResult) {
  /**
   * Nothing is returned from the dialog box. This means that the modal dialog continues running.
   */
  DialogResult[DialogResult["None"] = 0] = "None";
  /**
   * The dialog box return value is OK (usually sent from a button labeled OK).
   */
  DialogResult[DialogResult["OK"] = 1] = "OK";
  /**
   * The dialog box return value is Cancel (usually sent from a button labeled Cancel).
   */
  DialogResult[DialogResult["Cancel"] = 2] = "Cancel";
  /**
   * The dialog box return value is Abort (usually sent from a button labeled Abort).
   */
  DialogResult[DialogResult["Abort"] = 3] = "Abort";
  /**
   * The dialog box return value is Retry (usually sent from a button labeled Retry).
   */
  DialogResult[DialogResult["Retry"] = 4] = "Retry";
  /**
   * The dialog box return value is Ignore (usually sent from a button labeled Ignore).
   */
  DialogResult[DialogResult["Ignore"] = 5] = "Ignore";
  /**
   * The dialog box return value is Yes (usually sent from a button labeled Yes).
   */
  DialogResult[DialogResult["Yes"] = 6] = "Yes";
  /**
   * The dialog box return value is No (usually sent from a button labeled No).
   */
  DialogResult[DialogResult["No"] = 7] = "No";
})(DialogResult || (DialogResult = {}));
/**
 * Specifies constants defining which buttons to display on a System.Windows.Forms.MessageBox.
 */
var MessageBoxButtons;
(function (MessageBoxButtons) {
  /**
   * The message box contains an OK button.
   */
  MessageBoxButtons[MessageBoxButtons["OK"] = 0] = "OK";
  /**
   * The message box contains OK and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["OKCancel"] = 1] = "OKCancel";
  /**
   * The message box contains Abort, Retry, and Ignore buttons.
   */
  MessageBoxButtons[MessageBoxButtons["AbortRetryIgnore"] = 2] = "AbortRetryIgnore";
  /**
   * The message box contains Yes, No, and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["YesNoCancel"] = 3] = "YesNoCancel";
  /**
   * The message box contains Yes and No buttons.
   */
  MessageBoxButtons[MessageBoxButtons["YesNo"] = 4] = "YesNo";
  /**
   * The message box contains Retry and Cancel buttons.
   */
  MessageBoxButtons[MessageBoxButtons["RetryCancel"] = 5] = "RetryCancel";
  MessageBoxButtons[MessageBoxButtons["Custom"] = 6] = "Custom";
})(MessageBoxButtons || (MessageBoxButtons = {}));
/**
 * Specifies constants defining which information to display.
 */
var MessageBoxIcon;
(function (MessageBoxIcon) {
  /**
   * The message box contain no symbols.
   */
  MessageBoxIcon[MessageBoxIcon["None"] = 0] = "None";
  /**
   * The message box contains a symbol consisting of a white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Hand"] = 1] = "Hand";
  /**
   * The message box contains a symbol consisting of white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Stop"] = 2] = "Stop";
  /**
   * The message box contains a symbol consisting of white X in a circle with a red background.
   */
  MessageBoxIcon[MessageBoxIcon["Error"] = 3] = "Error";
  /**
   * The message box contains a symbol consisting of a question mark in a circle.
    * The question-mark message icon is no longer recommended because it does not clearly
    * represent a specific type of message and because the phrasing of a message as
    * a question could apply to any message type. In addition, users can confuse the
    * message symbol question mark with Help information. Therefore, do not use this
    * question mark message symbol in your message boxes. The system continues to support
    * its inclusion only for backward compatibility.
   */
  MessageBoxIcon[MessageBoxIcon["Question"] = 4] = "Question";
  /**
   * The message box contains a symbol consisting of an exclamation point in a triangle with a yellow background.
   */
  MessageBoxIcon[MessageBoxIcon["Exclamation"] = 5] = "Exclamation";
  /**
   * The message box contains a symbol consisting of an exclamation point in a triangle with a yellow background.
   */
  MessageBoxIcon[MessageBoxIcon["Warning"] = 6] = "Warning";
  /**
   * The message box contains a symbol consisting of a lowercase letter i in a circle.
   */
  MessageBoxIcon[MessageBoxIcon["Asterisk"] = 7] = "Asterisk";
  /**
   * The message box contains a symbol consisting of a lowercase letter i in a circle.
   */
  MessageBoxIcon[MessageBoxIcon["Information"] = 8] = "Information";
})(MessageBoxIcon || (MessageBoxIcon = {}));
var SwipeDirection;
(function (SwipeDirection) {
  SwipeDirection[SwipeDirection["Left"] = 0] = "Left";
  SwipeDirection[SwipeDirection["Right"] = 1] = "Right";
  SwipeDirection[SwipeDirection["Up"] = 2] = "Up";
  SwipeDirection[SwipeDirection["Down"] = 3] = "Down";
})(SwipeDirection || (SwipeDirection = {}));
var LinkTarget;
(function (LinkTarget) {
  /**
   * Load in a new window
   */
  LinkTarget["Blank"] = "_blank";
  /**
   * Load in the same frame as it was clicked
   */
  LinkTarget["Self"] = "_self";
})(LinkTarget || (LinkTarget = {}));
var BaseInputType;
(function (BaseInputType) {
  BaseInputType["Text"] = "text";
  BaseInputType["Email"] = "email";
  BaseInputType["Url"] = "url";
  BaseInputType["Password"] = "password";
  BaseInputType["Number"] = "number";
  BaseInputType["Currency"] = "currency";
  BaseInputType["TextArea"] = "textarea";
  BaseInputType["Dropdown"] = "dropdown";
  BaseInputType["Checkbox"] = "checkbox";
  BaseInputType["File"] = "file";
})(BaseInputType || (BaseInputType = {}));
var InputValidationRule;
(function (InputValidationRule) {
  /**
   * Default empty matcher
   */
  InputValidationRule["Default"] = "";
  /**
   * Value must be a proper email form
   * RFC-2822 validation regex from https://regexr.com/2rhq7
   * Latest Internet message format is described by RFC-5322, but this one should also do the job
   */
  InputValidationRule["Email"] = "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";
  /**
   * Value must be a proper url form, no port number or localhost supported
   */
  InputValidationRule["Url"] = "(https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,})";
  /**
   * Value must contain at least 1 lowercase, 1 uppercase character and 1 special character
   * Value must be 8 characters or longer
   */
  InputValidationRule["Password"] = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9 :])(?=.{8,})";
  /**
   * Generalish phone number validation. Requires 5-15 numbers separated by arbtirary amount of separators.
   *
   * Example matched numbers (source: https://stdcxx.apache.org/doc/stdlibug/26-1.html and self generated):
   *
   * 754-3010
   *
   * (541) 754-3010
   *
   * +1-541-754-3010
   *
   * 1-541-754-3010
   *
   * 001-541-754-3010
   *
   * 191 541 754 3010
   *
   * 636-48018
   *
   * (089) / 636-48018
   *
   * +49-89-636-48018
   *
   * 19-49-89-636-48018
   *
   * +358 123 456 789
   *
   * 044 440 040 045
   *
   * 020202
   *
   * 02 02 02
   *
   * 020 202
   */
  InputValidationRule["Phone"] = "^\\+?([- ()/]*[0-9][-()/]*){5,15}$";
})(InputValidationRule || (InputValidationRule = {}));
var PasswordValidationRule;
(function (PasswordValidationRule) {
  PasswordValidationRule["LowerCaseCharacter"] = "^(?=.*[a-z])";
  PasswordValidationRule["UpperCaseCharacter"] = "^(?=.*[A-Z])";
  PasswordValidationRule["NumberCharacter"] = "^(?=.*[0-9])";
  PasswordValidationRule["SpecialCharacter"] = "^(?=.*[^a-zA-Z0-9 :])";
})(PasswordValidationRule || (PasswordValidationRule = {}));
var PasswordValidationError;
(function (PasswordValidationError) {
  /**
   * One lowercase ('a'-'z') characters.
   */
  PasswordValidationError[PasswordValidationError["Lowercase"] = 0] = "Lowercase";
  /**
   * One uppercase ('A'-'Z') characters.
   */
  PasswordValidationError[PasswordValidationError["Uppercase"] = 1] = "Uppercase";
  /**
   * One non alphanumeric characters.
   */
  PasswordValidationError[PasswordValidationError["NonAlphabetic"] = 2] = "NonAlphabetic";
  /**
   * Min 6 and at max 100 characters long.
   */
  PasswordValidationError[PasswordValidationError["Length"] = 3] = "Length";
})(PasswordValidationError || (PasswordValidationError = {}));
var ActionType;
(function (ActionType) {
  ActionType[ActionType["Default"] = 0] = "Default";
  /**
   * "text-success"
   */
  ActionType[ActionType["Create"] = 1] = "Create";
  ActionType[ActionType["Edit"] = 2] = "Edit";
  /**
   * red
   */
  ActionType[ActionType["Delete"] = 3] = "Delete";
  /**
   * grey
   */
  ActionType[ActionType["Muted"] = 4] = "Muted";
  /**
   * "text-light"
   */
  ActionType[ActionType["Light"] = 5] = "Light";
  /**
   * "text-secondary"
   */
  ActionType[ActionType["Secondary"] = 6] = "Secondary";
  /**
   * cyan
   */
  ActionType[ActionType["Info"] = 7] = "Info";
  ActionType[ActionType["Grey"] = 8] = "Grey";
  ActionType[ActionType["Blue"] = 9] = "Blue";
})(ActionType || (ActionType = {}));
var TabBadgeShape;
(function (TabBadgeShape) {
  TabBadgeShape[TabBadgeShape["Pill"] = 0] = "Pill";
  TabBadgeShape[TabBadgeShape["Square"] = 1] = "Square";
})(TabBadgeShape || (TabBadgeShape = {}));

class CountryInfo {
  constructor() {
    /**
     * Name of the country in one of its native languages.
     *
     * @example Suomi
     */
    this.name = "";
    /**
     * Name of the country in English.
     *
     * @example Finland
     */
    this.englishName = "";
    /**
     * Country code.
     *
     * @example fi
     */
    this.code = "";
    /**
     * Language-region tag.
     *
     * @example sv-fi
     */
    this.culture = "";
    /**
     * Aliases of the Country.
     *
     * @example フィンランド, Murica
     */
    this.aliases = [];
    /**
     * For type checking.
     */
    this.isCountryInfo = true;
  }
}

class AlertModel {
  constructor(message = "", alertType = AlertType.Success, autoClose = false, flyout = false) {
    /**
     * Message displayed in the alert.
     *
     * @default ""
     */
    this.message = "";
    /**
     * @default null
     */
    this.messageParams = null;
    /**
     * Type of the alert. Mainly affects coloring.
     *
     * @default {@link AlertType.Success}
     */
    this.alertType = AlertType.Success;
    /**
     * Should the alert be user dismissable.
     *
     * @default true
     */
    this.dismissible = true;
    /**
     * Should the alert be automatically closed after {@link autoCloseDelay} milliseconds.
     *
     * @default false
     */
    this.autoClose = false;
    /**
     * After how many milliseconds should the alert be closed if {@link autoClose} is set to true.
     *
     * @default 5000
     */
    this.autoCloseDelay = 5000;
    /**
     * Should the alert fly out from the side of the sceen instead of being contained within the main PageContainer.
     *
     * @default false
     */
    this.flyout = false;
    /**
     * For type checking.
     *
     * @default true
     */
    this.isAlertModel = true;
    this.message = message;
    this.alertType = alertType;
    this.autoClose = autoClose;
    this.flyout = flyout;
  }
  static isEqual(x, y) {
    return Utility.getHashCode(x) === Utility.getHashCode(y);
  }
}

class BasePageParameters {}

class ApplicationContext {
  constructor() {
    this.id = "";
    this.version = "";
    this.versionId = "";
    this.newVersionInformation = null;
    this.language = "";
    this.country = "";
    this.xsrfToken = null;
    this.currentPage = null;
    this.applicationName = "";
    this.trace = null;
    this.timezoneOffset = 0;
    this.applicationType = WebApplicationType.DesktopBrowser;
    this.settings = {};
    this.isDevelopment = false;
    this.isStaging = false;
    this.mobileApp = false;
    this.pwaApp = false;
    this.desktopBrowser = false;
    this.mobileBrowser = false;
    this.isApplicationContext = true;
  }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$o =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$n = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$m = fails$n;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$m(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$l = fails$n;

var functionBindNative = !fails$l(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$k = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$k.bind(call$k) : function () {
  return call$k.apply(call$k, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$j = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$j, call$j);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$j.apply(fn, arguments);
  };
};

var uncurryThis$p = functionUncurryThis;

var toString$d = uncurryThis$p({}.toString);
var stringSlice$8 = uncurryThis$p(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$8(toString$d(it), 8, -1);
};

var uncurryThis$o = functionUncurryThis;
var fails$k = fails$n;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$o(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$k(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$7 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$6 = isNullOrUndefined$7;

var $TypeError$f = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$a = function (it) {
  if (isNullOrUndefined$6(it)) throw new $TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$9 = requireObjectCoercible$a;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$9(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$m = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$l = isCallable$m;

var isObject$b = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$l(it);
};

var global$n = global$o;
var isCallable$k = isCallable$m;

var aFunction = function (argument) {
  return isCallable$k(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$n[namespace]) : global$n[namespace] && global$n[namespace][method];
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$m = global$o;
var userAgent$3 = engineUserAgent;

var process$3 = global$m.process;
var Deno$1 = global$m.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$j = fails$n;
var global$l = global$o;

var $String$5 = global$l.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$j(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$j = isCallable$m;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$j($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$i = isCallable$m;
var tryToString$3 = tryToString$4;

var $TypeError$e = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$8 = function (argument) {
  if (isCallable$i(argument)) return argument;
  throw new $TypeError$e(tryToString$3(argument) + ' is not a function');
};

var aCallable$7 = aCallable$8;
var isNullOrUndefined$5 = isNullOrUndefined$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$5(func) ? undefined : aCallable$7(func);
};

var call$i = functionCall;
var isCallable$h = isCallable$m;
var isObject$a = isObject$b;

var $TypeError$d = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$h(fn = input.toString) && !isObject$a(val = call$i(fn, input))) return val;
  if (isCallable$h(fn = input.valueOf) && !isObject$a(val = call$i(fn, input))) return val;
  if (pref !== 'string' && isCallable$h(fn = input.toString) && !isObject$a(val = call$i(fn, input))) return val;
  throw new $TypeError$d("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$k = global$o;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$k, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$k[key] = value;
  } return value;
};

var global$j = global$o;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$j[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.35.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$8 = requireObjectCoercible$a;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$5 = function (argument) {
  return $Object$2(requireObjectCoercible$8(argument));
};

var uncurryThis$m = functionUncurryThis;
var toObject$4 = toObject$5;

var hasOwnProperty = uncurryThis$m({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$4(it), key);
};

var uncurryThis$l = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$c = uncurryThis$l(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$c(++id + postfix, 36);
};

var global$i = global$o;
var shared$3 = shared$4.exports;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = global$i.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$j = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$b(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$h = functionCall;
var isObject$9 = isObject$b;
var isSymbol$1 = isSymbol$2;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$i = wellKnownSymbol$j;

var $TypeError$c = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$i('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$9(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$h(exoticToPrim, input, pref);
    if (!isObject$9(result) || isSymbol$1(result)) return result;
    throw new $TypeError$c("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$h = global$o;
var isObject$8 = isObject$b;

var document$3 = global$h.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$8(document$3) && isObject$8(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$c = descriptors;
var fails$i = fails$n;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$b = descriptors;
var call$g = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$2(!call$g(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$a = descriptors;
var fails$h = fails$n;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$h(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$7 = isObject$b;

var $String$3 = String;
var $TypeError$b = TypeError;

// `Assert: Type(argument) is Object`
var anObject$g = function (argument) {
  if (isObject$7(argument)) return argument;
  throw new $TypeError$b($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$f = anObject$g;
var toPropertyKey = toPropertyKey$2;

var $TypeError$a = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$f(O);
  P = toPropertyKey(P);
  anObject$f(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$f(O);
  P = toPropertyKey(P);
  anObject$f(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$8 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$8 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$7 = descriptors;
var hasOwn$9 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$9(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || (DESCRIPTORS$7 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$k = functionUncurryThis;
var isCallable$g = isCallable$m;
var store$1 = sharedStore;

var functionToString = uncurryThis$k(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$g(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$g = global$o;
var isCallable$f = isCallable$m;

var WeakMap$1 = global$g.WeakMap;

var weakMapBasicDetection = isCallable$f(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$f = global$o;
var isObject$6 = isObject$b;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$8 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$f.TypeError;
var WeakMap = global$f.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$6(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$j = functionUncurryThis;
var fails$g = fails$n;
var isCallable$e = isCallable$m;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$6 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$2 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$7 = uncurryThis$j(''.slice);
var replace$4 = uncurryThis$j(''.replace);
var join = uncurryThis$j([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$6 && !fails$g(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$7($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$4($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$6) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$6) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$e(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$d = isCallable$m;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$7 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$d(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$1 = Math.max;
var min$5 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$1(integer + length, 0) : min$5(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$4 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$5 = function (argument) {
  var len = toIntegerOrInfinity$3(argument);
  return len > 0 ? min$4(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$4 = toLength$5;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$4(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$i = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$2 = uncurryThis$i([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$6(hiddenKeys$2, key) && hasOwn$6(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$6(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$h = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$e = anObject$g;

var concat$2 = uncurryThis$h([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$e(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$f = fails$n;
var isCallable$c = isCallable$m;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$c(detection) ? fails$f(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$e = global$o;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$6 = defineBuiltIn$7;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$e;
  } else if (STATIC) {
    target = global$e[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$e[TARGET] && global$e[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$6(target, key, sourceProperty, options);
  }
};

var wellKnownSymbol$h = wellKnownSymbol$j;

var TO_STRING_TAG$2 = wellKnownSymbol$h('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$b = isCallable$m;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$g = wellKnownSymbol$j;

var TO_STRING_TAG$1 = wellKnownSymbol$g('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$b(O.callee) ? 'Arguments' : result;
};

var classof$6 = classof$7;

var $String$1 = String;

var toString$b = function (argument) {
  if (classof$6(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$4 = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$4.f(target, name, descriptor);
};

var $$g = _export;
var DESCRIPTORS$5 = descriptors;
var global$d = global$o;
var uncurryThis$g = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var isCallable$a = isCallable$m;
var isPrototypeOf$3 = objectIsPrototypeOf;
var toString$a = toString$b;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$d.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$5 && isCallable$a(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$a(arguments[0]);
    var result = isPrototypeOf$3(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$g(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$g(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$g(''.replace);
  var stringSlice$6 = uncurryThis$g(''.slice);

  defineBuiltInAccessor$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$4(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$6(string, 7, -1) : replace$3(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$g({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

class DescriptionModel {
  constructor() {
    this.readonly = false;
    this.className = null;
    this.description = "";
    this.align = Align.Bottom;
    this.justify = Justify.Left;
    /**
     * Max length for the description text area.
     */
    this.maxLength = null;
    this.isDescriptionModel = true;
  }
}

var DocumentPreviewSize;
(function (DocumentPreviewSize) {
  DocumentPreviewSize[DocumentPreviewSize["Large"] = 0] = "Large";
  DocumentPreviewSize[DocumentPreviewSize["Medium"] = 1] = "Medium";
})(DocumentPreviewSize || (DocumentPreviewSize = {}));
class DocumentPreviewModel {
  constructor() {
    this.title = null;
    this.subtitle = null;
    this.size = DocumentPreviewSize.Large;
    this.document = new FileModel();
  }
}

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$4 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$d = anObject$g;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$4 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$d(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$c = anObject$g;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$c(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$f = wellKnownSymbol$j;
var create$2 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$e = fails$n;

var correctPrototypeGetter = !fails$e(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$9 = isCallable$m;
var toObject$3 = toObject$5;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$9(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$d = fails$n;
var isCallable$8 = isCallable$m;
var isObject$5 = isObject$b;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$5 = defineBuiltIn$7;
var wellKnownSymbol$e = wellKnownSymbol$j;

var ITERATOR$6 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$5(IteratorPrototype$2) || fails$d(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$6].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$8(IteratorPrototype$2[ITERATOR$6])) {
  defineBuiltIn$5(IteratorPrototype$2, ITERATOR$6, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$j;

var TO_STRING_TAG = wellKnownSymbol$d('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG)) {
    defineProperty$2(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$3 = setToStringTag$4;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$f = functionUncurryThis;
var aCallable$6 = aCallable$8;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$f(aCallable$6(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$4 = isObject$b;

var isPossiblePrototype$1 = function (argument) {
  return isObject$4(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String = String;
var $TypeError$9 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$9("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$b = anObject$g;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$b(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$f = _export;
var call$f = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$m;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$4 = defineBuiltIn$7;
var wellKnownSymbol$c = wellKnownSymbol$j;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$5]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$5])) {
          defineBuiltIn$4(CurrentIteratorPrototype, ITERATOR$5, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$2 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$f(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$4(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$f({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$5] !== defaultIterator) {
    defineBuiltIn$4(IterablePrototype, ITERATOR$5, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$3 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$3 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var DESCRIPTORS$2 = descriptors;
var uncurryThis$e = functionUncurryThis;
var call$e = functionCall;
var fails$c = fails$n;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$5;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat$1 = uncurryThis$e([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$c(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || call$e(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$e = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$e({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$c = global$o;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$b = wellKnownSymbol$j;

var ITERATOR$4 = wellKnownSymbol$b('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$4] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$4, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$4] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$c[COLLECTION_NAME] && global$c[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

class PageRoute {
  constructor(name, index = null, id = null, parameters = null, urlParams = null) {
    this.isPageRoute = true;
    this.name = name;
    this.index = index;
    this.id = id;
    this.parameters = parameters !== null && parameters !== void 0 ? parameters : {};
    this.urlParams = urlParams !== null && urlParams !== void 0 ? urlParams : [];
    this.isPageRoute = true;
  }
  /**
   * Clone a {@link PageRoute}.
   *
   * @param route Route to clone.
   */
  static clone(route) {
    var _a;
    return new PageRoute(route.name, route.index, route.id, Object.assign({}, route.parameters), [...((_a = route.urlParams) !== null && _a !== void 0 ? _a : [])]);
  }
  /**
   * Convert a {@link PageRoute} to a relative path.
   *
   * @param route Route to convert to a path.
   */
  static toRelativePath(route) {
    var _a;
    let path = "/";
    const localizer = ServiceProvider.findLocalizer();
    const localizedRouteKey = `PageRoutes.${route.name}`;
    const pageName = (localizer === null || localizer === void 0 ? void 0 : localizer.contains(localizedRouteKey, localizer === null || localizer === void 0 ? void 0 : localizer.language)) ? localizer.get(localizedRouteKey) : route.name;
    // "/pageName"
    path += pageName;
    // Id can only be set in non-root pages, as otherwise it would be considered as the page name.
    if (pageName && route.id) {
      // "/pageName/id"
      path += `/${route.id}`;
      // "/pageName/id/param1/param2/..."
      if ((_a = route.urlParams) === null || _a === void 0 ? void 0 : _a.length) {
        for (const urlParam of route.urlParams) {
          path += `/${urlParam}`;
        }
      }
    }
    if (route.parameters) {
      let query = "";
      //Querystring.stringify had a problem with parameters object so had to do it this way
      for (const [key, value] of Object.entries(route.parameters)) {
        const improper = !key || typeof value === "function" || typeof value === "symbol";
        if (improper) {
          continue;
        }
        if (query) {
          query += "&";
        }
        const properValue = typeof value === "object" ? JSON.stringify(value) : value;
        query += `${key}=${properValue}`;
      }
      if (query) {
        // "/pageName{/id}?query=query&query=query"
        path += `?${query}`;
      }
    }
    return path;
  }
  static normalize(route) {
    if (!route) {
      return;
    }
    if (!route.id) {
      route.id = null;
    }
    if (!route.urlParams) {
      route.urlParams = [];
    }
    if (!route.parameters) {
      route.parameters = {};
    }
  }
  static isEqual(x, y) {
    if (x === y) {
      return true;
    }
    if (x == null && y == null) {
      return true;
    }
    if (x == null || y == null) {
      return false;
    }
    if (x.name !== y.name) {
      return false;
    }
    if (x.index !== y.index) {
      return false;
    }
    if (x.id !== y.id) {
      return false;
    }
    if (Utility.getHashCode(x.urlParams) != Utility.getHashCode(y.urlParams)) {
      return false;
    }
    if (x.parameters == null && y.parameters == null) {
      return true;
    }
    if (Utility.getHashCode(x.parameters) != Utility.getHashCode(y.parameters)) {
      return false;
    }
    return true;
  }
}

class ServerError {
  constructor(requestId) {
    this.requestId = requestId;
  }
}

class ArrayScope {
  constructor() {
    this.firstIndex = 0;
    this.lastIndex = 0;
    this.isArrayScope = true;
  }
}

class EnvironmentCountry {
  constructor() {
    this.countryCodes = [];
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var anObject$a = anObject$g;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call$d = functionCall;
var hasOwn$1 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$1(R, 'flags') && isPrototypeOf$2(RegExpPrototype$2, R)
    ? call$d(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$3 = defineBuiltIn$7;
var anObject$9 = anObject$g;
var $toString = toString$b;
var fails$b = fails$n;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$b(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$3(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$9(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var classof$5 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$5(argument) === 'Array';
};

var $TypeError$8 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$1 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$8('Maximum allowed index exceeded');
  return it;
};

var classofRaw = classofRaw$2;
var uncurryThis$d = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$d(fn);
};

var uncurryThis$c = functionUncurryThisClause;
var aCallable$5 = aCallable$8;
var NATIVE_BIND$1 = functionBindNative;

var bind$5 = uncurryThis$c(uncurryThis$c.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$5(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var isArray$1 = isArray$2;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$1;
var bind$4 = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind$4(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$2(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var uncurryThis$b = functionUncurryThis;
var fails$a = fails$n;
var isCallable$6 = isCallable$m;
var classof$4 = classof$7;
var getBuiltIn$3 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$2 = uncurryThis$b(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$6(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$6(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$2(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$a(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isArray = isArray$2;
var isConstructor$1 = isConstructor$2;
var isObject$3 = isObject$b;
var wellKnownSymbol$a = wellKnownSymbol$j;

var SPECIES$4 = wellKnownSymbol$a('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject$3(C)) {
      C = C[SPECIES$4];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$d = _export;
var flattenIntoArray = flattenIntoArray_1;
var toObject$1 = toObject$5;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$$d({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject$1(this);
    var sourceLen = lengthOfArrayLike$1(O);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity$2(depthArg));
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables$1 = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('flat');

var fails$9 = fails$n;
var global$b = global$o;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$b.RegExp;

var UNSUPPORTED_Y$2 = fails$9(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$9(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$9(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$8 = fails$n;
var global$a = global$o;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$a.RegExp;

var regexpUnsupportedDotAll = fails$8(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$7 = fails$n;
var global$9 = global$o;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$9.RegExp;

var regexpUnsupportedNcg = fails$7(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$c = functionCall;
var uncurryThis$a = functionUncurryThis;
var toString$9 = toString$b;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$a(''.charAt);
var indexOf = uncurryThis$a(''.indexOf);
var replace$2 = uncurryThis$a(''.replace);
var stringSlice$5 = uncurryThis$a(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$c(nativeExec, re1, 'a');
  call$c(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$9(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$c(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$c(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$5(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$c(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$5(match.input, charsAdded);
        match[0] = stringSlice$5(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$c(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$c = _export;
var exec$1 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$c({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$b = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$b.bind(apply$2) : function () {
  return call$b.apply(apply$2, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$a = functionCall;
var defineBuiltIn$2 = defineBuiltIn$7;
var regexpExec$1 = regexpExec$2;
var fails$6 = fails$n;
var wellKnownSymbol$9 = wellKnownSymbol$j;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES$3 = wellKnownSymbol$9('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$9(KEY);

  var DELEGATES_TO_SYMBOL = !fails$6(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$6(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$a(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$a(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$2(String.prototype, KEY, methods[0]);
    defineBuiltIn$2(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var toString$8 = toString$b;
var requireObjectCoercible$7 = requireObjectCoercible$a;

var charAt$2 = uncurryThis$9(''.charAt);
var charCodeAt = uncurryThis$9(''.charCodeAt);
var stringSlice$4 = uncurryThis$9(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$8(requireObjectCoercible$7($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$8 = functionUncurryThis;
var toObject = toObject$5;

var floor = Math.floor;
var charAt = uncurryThis$8(''.charAt);
var replace$1 = uncurryThis$8(''.replace);
var stringSlice$3 = uncurryThis$8(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$9 = functionCall;
var anObject$8 = anObject$g;
var isCallable$5 = isCallable$m;
var classof$3 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$7 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$5(exec)) {
    var result = call$9(exec, R, S);
    if (result !== null) anObject$8(result);
    return result;
  }
  if (classof$3(R) === 'RegExp') return call$9(regexpExec, R, S);
  throw new $TypeError$7('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$8 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var fails$5 = fails$n;
var anObject$7 = anObject$g;
var isCallable$4 = isCallable$m;
var isNullOrUndefined$4 = isNullOrUndefined$7;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var toLength$3 = toLength$5;
var toString$7 = toString$b;
var requireObjectCoercible$6 = requireObjectCoercible$a;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$4 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$8 = wellKnownSymbol$j;

var REPLACE = wellKnownSymbol$8('replace');
var max = Math.max;
var min$3 = Math.min;
var concat = uncurryThis$7([].concat);
var push$1 = uncurryThis$7([].push);
var stringIndexOf$1 = uncurryThis$7(''.indexOf);
var stringSlice$2 = uncurryThis$7(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$5(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$2('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$6(this);
      var replacer = isNullOrUndefined$4(searchValue) ? undefined : getMethod$4(searchValue, REPLACE);
      return replacer
        ? call$8(replacer, searchValue, O, replaceValue)
        : call$8(nativeReplace, toString$7(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$7(this);
      var S = toString$7(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$4(replaceValue);
      if (!functionalReplace) replaceValue = toString$7(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$2(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString$7(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$3(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$7(result[0]);
        var position = max(min$3(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          replacement = toString$7(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$2(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$2(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var isConstructor = isConstructor$2;
var tryToString$2 = tryToString$4;

var $TypeError$6 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$6(tryToString$2(argument) + ' is not a constructor');
};

var anObject$6 = anObject$g;
var aConstructor = aConstructor$1;
var isNullOrUndefined$3 = isNullOrUndefined$7;
var wellKnownSymbol$7 = wellKnownSymbol$j;

var SPECIES$2 = wellKnownSymbol$7('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$3(S = anObject$6(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var call$7 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$5 = anObject$g;
var isNullOrUndefined$2 = isNullOrUndefined$7;
var requireObjectCoercible$5 = requireObjectCoercible$a;
var speciesConstructor$1 = speciesConstructor$2;
var advanceStringIndex = advanceStringIndex$2;
var toLength$2 = toLength$5;
var toString$6 = toString$b;
var getMethod$3 = getMethod$6;
var regExpExec$1 = regexpExecAbstract;
var stickyHelpers = regexpStickyHelpers;
var fails$4 = fails$n;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$2 = Math.min;
var push = uncurryThis$6([].push);
var stringSlice$1 = uncurryThis$6(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$4(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegExpWellKnownSymbolLogic$1('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : call$7(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$5(this);
      var splitter = isNullOrUndefined$2(separator) ? undefined : getMethod$3(separator, SPLIT);
      return splitter
        ? call$7(splitter, separator, O, limit)
        : call$7(internalSplit, toString$6(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$5(this);
      var S = toString$6(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor$1(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regExpExec$1(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regExpExec$1(splitter, UNSUPPORTED_Y ? stringSlice$1(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$2(toLength$2(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice$1(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice$1(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

class ReactUtility {
  //#region Private
  static split(regex, tag, text, containerIndex) {
    const items = (text || "").split(regex);
    const tags = items.map((item, index) => index % 2 != 0 ? [/*#__PURE__*/React.createElement(tag, {
      key: `_${containerIndex}${tag}${index}`
    }, item)] : [item]);
    return tags && Array.isArray(tags) && typeof tags.flat === "function" ? tags.flat().filter(tag => !!tag) : [];
  }
  static containerToTags(text, containerIndex) {
    let tags = this.containerToMarks(text, containerIndex);
    tags = this.invoke(tags, item => this.containerToSmalls(item, containerIndex));
    tags = this.invoke(tags, item => this.containerToItalics(item, containerIndex));
    tags = this.invoke(tags, item => this.containerToBolds(item, containerIndex));
    return tags;
  }
  static containerToMarks(text, containerIndex) {
    return this.split(AthenaeumConstants.markTagRegex, "mark", text, containerIndex);
  }
  static containerToSmalls(text, containerIndex) {
    return this.split(AthenaeumConstants.smallTagRegex, "small", text, containerIndex);
  }
  static containerToBolds(text, containerIndex) {
    return this.split(AthenaeumConstants.boldTagRegex, "b", text, containerIndex);
  }
  static containerToItalics(text, containerIndex) {
    return this.split(AthenaeumConstants.italicTagRegex, "i", text, containerIndex);
  }
  static invoke(tags, action) {
    const items = tags.map(item => {
      return typeof item === "string" ? action(item) : Array.isArray(item) ? this.invoke(item, action) : item;
    });
    return items && Array.isArray(items) && typeof items.flat === "function" ? items.flat() : [];
  }
  //#endregion
  static toMarks(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToMarks(text, 0);
  }
  static toSmalls(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToSmalls(text, 0);
  }
  static toBolds(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToBolds(text, 0);
  }
  static toItalics(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    return this.containerToItalics(text, 0);
  }
  static toSingleLine(text) {
    // check
    if (!text) {
      return "";
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return "";
    }
    return text.replace(AthenaeumConstants.newLineRegex, " ");
  }
  static toMultiLines(text) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    const lines = text.split(AthenaeumConstants.newLineRegex);
    const items = lines.map((line, index) => index < lines.length - 1 ? [...this.containerToTags(line, index), /*#__PURE__*/React.createElement("br", {
      key: "br" + index
    })] : [...this.containerToTags(line, index)]);
    return items && Array.isArray(items) && typeof items.flat === "function" ? items.flat() : [];
  }
  static toTags(text, toSingleLine = true) {
    // check
    if (!text) {
      return [];
    }
    // noinspection SuspiciousTypeOfGuard
    if (typeof text !== "string") {
      return [];
    }
    if (toSingleLine) {
      text = this.toSingleLine(text);
    }
    return this.containerToTags(text, 0);
  }
}

var global$8 = global$o;
var classof$2 = classofRaw$2;

var engineIsNode = classof$2(global$8.process) === 'process';

var getBuiltIn$2 = getBuiltIn$7;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$6 = wellKnownSymbol$j;
var DESCRIPTORS$1 = descriptors;

var SPECIES$1 = wellKnownSymbol$6('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$1 && Constructor && !Constructor[SPECIES$1]) {
    defineBuiltInAccessor(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$1 = objectIsPrototypeOf;

var $TypeError$5 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$1(Prototype, it)) return it;
  throw new $TypeError$5('Incorrect invocation');
};

var uncurryThis$5 = functionUncurryThis;

var arraySlice$1 = uncurryThis$5([].slice);

var $TypeError$4 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$4('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$7 = global$o;
var apply = functionApply;
var bind$3 = functionBindContext;
var isCallable$3 = isCallable$m;
var hasOwn = hasOwnProperty_1;
var fails$3 = fails$n;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$7.setImmediate;
var clear = global$7.clearImmediate;
var process$2 = global$7.process;
var Dispatch = global$7.Dispatch;
var Function$1 = global$7.Function;
var MessageChannel = global$7.MessageChannel;
var String$1 = global$7.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$3(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$7.location;
});

var run = function (id) {
  if (hasOwn(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$7.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$3(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$7.addEventListener &&
    isCallable$3(global$7.postMessage) &&
    !global$7.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$3(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$7.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$6 = global$o;
var DESCRIPTORS = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS) return global$6[name];
  var descriptor = getOwnPropertyDescriptor$2(global$6, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$5 = global$o;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$2 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var document$2 = global$5.document;
var process$1 = global$5.process;
var Promise$1 = global$5.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$2(macrotask, global$5);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$4 = global$o;

var promiseNativeConstructor = global$4.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$3 = global$o;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$2 = isCallable$m;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$5 = wellKnownSymbol$j;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES = wellKnownSymbol$5('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$2(global$3.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$4 = aCallable$8;

var $TypeError$3 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$3('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$4(resolve);
  this.reject = aCallable$4(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$b = _export;
var IS_NODE = engineIsNode;
var global$2 = global$o;
var call$6 = functionCall;
var defineBuiltIn$1 = defineBuiltIn$7;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$3 = aCallable$8;
var isCallable$1 = isCallable$m;
var isObject$2 = isObject$b;
var anInstance = anInstance$1;
var speciesConstructor = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$1(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$6(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$6(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$6(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$3(executor);
    call$6(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$1(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$1(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$1(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$1(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$1(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$6(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$b({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$4 = wellKnownSymbol$j;
var Iterators$1 = iterators;

var ITERATOR$3 = wellKnownSymbol$4('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$3] === it);
};

var classof$1 = classof$7;
var getMethod$2 = getMethod$6;
var isNullOrUndefined$1 = isNullOrUndefined$7;
var Iterators = iterators;
var wellKnownSymbol$3 = wellKnownSymbol$j;

var ITERATOR$2 = wellKnownSymbol$3('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined$1(it)) return getMethod$2(it, ITERATOR$2)
    || getMethod$2(it, '@@iterator')
    || Iterators[classof$1(it)];
};

var call$5 = functionCall;
var aCallable$2 = aCallable$8;
var anObject$4 = anObject$g;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$2 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$2(iteratorMethod)) return anObject$4(call$5(iteratorMethod, argument));
  throw new $TypeError$2(tryToString$1(argument) + ' is not iterable');
};

var call$4 = functionCall;
var anObject$3 = anObject$g;
var getMethod$1 = getMethod$6;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$4(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$3(innerResult);
  return value;
};

var bind = functionBindContext;
var call$3 = functionCall;
var anObject$2 = anObject$g;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike = lengthOfArrayLike$4;
var isPrototypeOf = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError$1 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$2(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$1(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$3(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$2 = wellKnownSymbol$j;

var ITERATOR$1 = wellKnownSymbol$2('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$1] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$a = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$8;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$a({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$2($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$9 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable = isCallable$m;
var defineBuiltIn = defineBuiltIn$7;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$9({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$8 = _export;
var call$1 = functionCall;
var aCallable = aCallable$8;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$8({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call$1($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$7 = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$1 = anObject$g;
var isObject$1 = isObject$b;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$1(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$6 = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$6({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var isObject = isObject$b;
var classof = classofRaw$2;
var wellKnownSymbol$1 = wellKnownSymbol$j;

var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$j;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$5 = _export;
var uncurryThis$4 = functionUncurryThisClause;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$5;
var toString$5 = toString$b;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$4 = requireObjectCoercible$a;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

var slice = uncurryThis$4(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$2('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$$5({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString$5(requireObjectCoercible$4(this));
    notARegExp$2(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$1(toLength$1(endPosition), len);
    var search = toString$5(searchString);
    return slice(that, end - search.length, end) === search;
  }
});

var $$4 = _export;
var uncurryThis$3 = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$5;
var toString$4 = toString$b;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$3 = requireObjectCoercible$a;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringSlice = uncurryThis$3(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic$1('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$4({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$4(requireObjectCoercible$3(this));
    notARegExp$1(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$4(searchString);
    return stringSlice(that, index, index + search.length) === search;
  }
});

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$2 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$a;
var toString$3 = toString$b;
var whitespaces$2 = whitespaces$3;

var replace = uncurryThis$2(''.replace);
var ltrim = RegExp('^[' + whitespaces$2 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$3(requireObjectCoercible$2($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$2 = fails$n;
var whitespaces$1 = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$2(function () {
    return !!whitespaces$1[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces$1[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$3 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$3({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$g;
var isNullOrUndefined = isNullOrUndefined$7;
var requireObjectCoercible$1 = requireObjectCoercible$a;
var sameValue = sameValue$1;
var toString$2 = toString$b;
var getMethod = getMethod$6;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$2(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString$2(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var $$2 = _export;
var $includes = arrayIncludes.includes;
var fails$1 = fails$n;
var addToUnscopables = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$1(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$2({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var $$1 = _export;
var uncurryThis$1 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$a;
var toString$1 = toString$b;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$1(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$1({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$1(requireObjectCoercible(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

class EnvironmentCountryHelper {
  /**
   * Check if given country or language code matches with any of the specified country's codes
   * @param country Countrycode to check
   * @param environmentCountry Codes to check against
   */
  static isEnvironmentCountry(country, environmentCountry) {
    return environmentCountry.countryCodes.includes(country);
  }
}
EnvironmentCountryHelper.languageCodes = {
  danish: "da",
  english: "en",
  finnish: "fi",
  norwegian: "nb",
  polish: "pl",
  swedish: "sv"
};
EnvironmentCountryHelper.countryCodes = {
  denmark: "dk",
  finland: "fi",
  norway: "no",
  poland: "pl",
  sweden: "se"
};
EnvironmentCountryHelper.finland = {
  countryCodes: [EnvironmentCountryHelper.languageCodes.finnish, EnvironmentCountryHelper.countryCodes.finland]
};
EnvironmentCountryHelper.sweden = {
  countryCodes: [EnvironmentCountryHelper.languageCodes.swedish, EnvironmentCountryHelper.countryCodes.sweden]
};
EnvironmentCountryHelper.norway = {
  countryCodes: [EnvironmentCountryHelper.languageCodes.norwegian, EnvironmentCountryHelper.countryCodes.norway, "nor"]
};
EnvironmentCountryHelper.denmark = {
  countryCodes: [EnvironmentCountryHelper.languageCodes.danish, EnvironmentCountryHelper.countryCodes.denmark]
};
EnvironmentCountryHelper.poland = {
  countryCodes: [EnvironmentCountryHelper.languageCodes.polish, EnvironmentCountryHelper.countryCodes.poland]
};

/**
 * {@link BaseComponent} helper.
 * Provides helper functions for component initialization.
 */
class ch {
  // Properties
  /**
   * {@link ILayoutPage.alert} of the current {@link ILayoutPage}
   */
  static get alert() {
    var _a, _b;
    return (_b = (_a = this._layout) === null || _a === void 0 ? void 0 : _a.alert) !== null && _b !== void 0 ? _b : null;
  }
  /**
   * {@link ApplicationContext.country} of the current {@link ApplicationContext}
   *
   * @throws The current {@link ApplicationContext} is not defined
   */
  static get country() {
    const context = this.getContext();
    return context.country;
  }
  static get isSweden() {
    const country = this.country;
    return EnvironmentCountryHelper.isEnvironmentCountry(country, EnvironmentCountryHelper.sweden);
  }
  static get isFinland() {
    const country = this.country;
    return EnvironmentCountryHelper.isEnvironmentCountry(country, EnvironmentCountryHelper.finland);
  }
  static get isNorway() {
    const country = this.country;
    return EnvironmentCountryHelper.isEnvironmentCountry(country, EnvironmentCountryHelper.norway);
  }
  static get isDenmark() {
    const country = this.country;
    return EnvironmentCountryHelper.isEnvironmentCountry(country, EnvironmentCountryHelper.denmark);
  }
  static get isPoland() {
    const country = this.country;
    return EnvironmentCountryHelper.isEnvironmentCountry(country, EnvironmentCountryHelper.poland);
  }
  static get debug() {
    return this._debug;
  }
  static set debug(value) {
    this._debug = value;
  }
  /**
   * true if the current {@link window.innerWidth} is above {@link AthenaeumConstants.desktopMinWidth}; false otherwise
   *
   * @see mobile
   * @see mobileApp
   */
  static get desktop() {
    return window.innerWidth >= AthenaeumConstants.desktopMinWidth;
  }
  /**
   * true if the current {@link IUserContext} is defined and it has a defined {@link IUserContext.user}; false otherwise
   */
  static get isAuthenticated() {
    const user = this.findUser();
    return !!user;
  }
  /**
   * true if the current {@link ApplicationContext} is defined and its {@link ApplicationContext.isDevelopment} is true; false otherwise
   */
  static get isDevelopment() {
    var _a;
    return ((_a = this._context) === null || _a === void 0 ? void 0 : _a.isDevelopment) === true;
  }
  /**
   * {@link ApplicationContext.language} of the current {@link ApplicationContext}
   *
   * @throws The current {@link ApplicationContext} is not defined
   */
  static get language() {
    const context = this.getContext();
    return context.language;
  }
  /**
   * negation of {@link desktop}
   *
   * @see mobileApp
   */
  static get mobile() {
    return !this.desktop;
  }
  /**
   * true if the current {@link ApplicationContext} is defined and its {@link ApplicationContext.mobileApp} is true; false otherwise
   *
   * @see desktop
   * @see mobile
   */
  static get mobileApp() {
    var _a;
    return ((_a = this._context) === null || _a === void 0 ? void 0 : _a.mobileApp) === true;
  }
  /**
   * {@link ApplicationContext.version} of the current {@link ApplicationContext}, or empty string if the current {@link ApplicationContext} or its {@link ApplicationContext.version} are not defined
   */
  static get version() {
    var _a, _b;
    return (_b = (_a = this._context) === null || _a === void 0 ? void 0 : _a.version) !== null && _b !== void 0 ? _b : "";
  }
  // Methods
  static onOnSetLanguageAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield ApiProvider.postAsync("/api/Application/OnSetLanguage", language, null);
      } catch (e) {
        //no additional action needed, not critical
        console.error(e);
      }
    });
  }
  static onInitializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this._initializeCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
        return yield callback();
      }));
    });
  }
  static onAuthorizeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield Utility.forEachAsync(this._authorizeCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
        return yield callback();
      }));
    });
  }
  /**
   * If the input {@link IBaseComponent} is an {@link ILayoutPage}, set it as the current {@link ILayoutPage},
   * or if it is an {@link IBasePage}, set it as the current {@link IBasePage}.
   * Otherwise do nothing.
   *
   * @param component {@link IBaseComponent} to set as the current {@link ILayoutPage} or {@link IBasePage}.
   */
  static register(component) {
    var _a, _b;
    const layout = component;
    if ((_a = layout === null || layout === void 0 ? void 0 : layout.isLayout) === null || _a === void 0 ? void 0 : _a.call(layout)) {
      this._layout = layout;
      return;
    }
    const page = component;
    if ((_b = page === null || page === void 0 ? void 0 : page.isPage) === null || _b === void 0 ? void 0 : _b.call(page)) {
      this._page = page;
      return;
    }
  }
  /**
   * Sets context
   *
   * @param context {@link ApplicationContext} to set as the current context
   */
  static setContextAsync(context) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._context !== context) {
        const authorize = !!this._context && this._context.username !== context.username;
        //set context
        const oldContext = this._context;
        this._context = context;
        if (!this._initialized) {
          this._initialized = true;
          yield this.onInitializeAsync();
        }
        if (authorize) {
          yield this.onAuthorizeAsync();
        }
        if (this._layout != null) {
          yield this._layout.contextChangedAsync(oldContext, context);
        }
      }
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.reloadTopNavAsync}
   */
  static reloadTopNavAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_a = this._layout) === null || _a === void 0 ? void 0 : _a.reloadTopNavAsync();
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.reloadLeftNavAsync}
   */
  static reloadLeftNavAsync() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_a = this._layout) === null || _a === void 0 ? void 0 : _a.reloadLeftNavAsync();
    });
  }
  /**
   * Calls {@link reloadTopNavAsync} without awaiting
   */
  static reloadTopNav() {
    // noinspection JSIgnoredPromiseFromCall
    this.reloadTopNavAsync();
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync}
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param alert {@link AlertModel} passed to {@link ILayoutPage.alertAsync}
   */
  static alertAsync(alert) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      yield (_a = this._layout) === null || _a === void 0 ? void 0 : _a.alertAsync(alert);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel} which {@link AlertModel.alertType} is {@link AlertType.Success}
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param autoClose {@link AlertModel.autoClose} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param flyout {@link AlertModel.flyout} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see flyoutMessageAsync
   * @see alertWarningAsync
   * @see flyoutWarningAsync
   * @see alertErrorAsync
   * @see flyoutErrorAsync
   */
  static alertMessageAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Success, autoClose, flyout);
      yield this.alertAsync(alert);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel}
   * which {@link AlertModel.alertType} is {@link AlertType.Success}, {@link AlertModel.flyout} is true and {@link AlertModel.autoClose} is true
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see alertMessageAsync
   * @see alertWarningAsync
   * @see flyoutWarningAsync
   * @see alertErrorAsync
   * @see flyoutErrorAsync
   */
  static flyoutMessageAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertMessageAsync(message, true, true);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel} which {@link AlertModel.alertType} is {@link AlertType.Warning}
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param autoClose {@link AlertModel.autoClose} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param flyout {@link AlertModel.flyout} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see alertMessageAsync
   * @see flyoutMessageAsync
   * @see flyoutWarningAsync
   * @see alertErrorAsync
   * @see flyoutErrorAsync
   */
  static alertWarningAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Warning, autoClose, flyout);
      yield this.alertAsync(alert);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel}
   * which {@link AlertModel.alertType} is {@link AlertType.Warning}, {@link AlertModel.flyout} is true and {@link AlertModel.autoClose} is true
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see alertMessageAsync
   * @see flyoutMessageAsync
   * @see alertWarningAsync
   * @see alertErrorAsync
   * @see flyoutErrorAsync
   */
  static flyoutWarningAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertWarningAsync(message, true, true);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel} which {@link AlertModel.alertType} is {@link AlertType.Danger}
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param autoClose {@link AlertModel.autoClose} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @param flyout {@link AlertModel.flyout} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see alertMessageAsync
   * @see flyoutMessageAsync
   * @see alertWarningAsync
   * @see flyoutWarningAsync
   * @see flyoutErrorAsync
   */
  static alertErrorAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      const alert = new AlertModel(message, AlertType.Danger, autoClose, flyout);
      yield this.alertAsync(alert);
    });
  }
  /**
   * If the current {@link ILayoutPage} is defined, calls its {@link ILayoutPage.alertAsync} with an {@link AlertModel}
   * which {@link AlertModel.alertType} is {@link AlertType.Danger}, {@link AlertModel.flyout} is true and {@link AlertModel.autoClose} is true
   *
   * NOTE: Only one alert can be displayed at the same time. If a previous alert exists, it will be overwritten by the new one
   *
   * @param message {@link AlertModel.message} of the {@link AlertModel} created and passed to {@link ILayoutPage.alertAsync}
   * @see alertAsync
   * @see alertMessageAsync
   * @see flyoutMessageAsync
   * @see alertWarningAsync
   * @see flyoutWarningAsync
   * @see alertErrorAsync
   */
  static flyoutErrorAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.alertErrorAsync(message, true, true);
    });
  }
  /**
   * Disable swipe navigation on page.
   */
  static preventSwipeNavigation() {
    const page = this.findPage();
    if (page) {
      page.onSwipeHandlerAsync = () => __awaiter(this, void 0, void 0, function* () {
        return false;
      });
    }
  }
  /**
   * Enable swipe navigation on page.
   */
  static restoreSwipeNavigation() {
    const page = this.findPage();
    if (page) {
      page.onSwipeHandlerAsync = () => __awaiter(this, void 0, void 0, function* () {
        return true;
      });
    }
  }
  /**
   * Hide the alert being displayed in the current {@link ILayoutPage}.
   */
  static hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.hideAlertAsync();
      }
    });
  }
  static confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._page != null && (yield this._page.confirmAsync(title));
    });
  }
  static messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      return this._page != null ? yield this._page.messageBoxAsync(titleOrModel, caption, buttons, icon) : DialogResult.None;
    });
  }
  static documentPreviewAsync(endpoint, request, title = null, size = DocumentPreviewSize.Large) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        const model = new DocumentPreviewModel();
        model.document = sender => __awaiter(this, void 0, void 0, function* () {
          return yield sender.postAsync(endpoint, request);
        });
        model.title = title;
        model.size = size;
        yield this._page.documentPreviewAsync(model);
      }
    });
  }
  /**
   * Specifies the URL of the resource to be used by the document preview.
   * @param url
   * Possible values:
   * An absolute URL - points to data on another web site (like href="http://www.example.com/images/pic_trulli.jpg")
   * A relative URL - points to data within a web site (like href="pic_trulli.jpg")
   */
  static documentPreviewFromUrlAsync(url) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        yield this._page.documentPreviewAsync(url);
      }
    });
  }
  static preloadedDocumentPreviewAsync(document, title = null, size = DocumentPreviewSize.Large) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        const model = new DocumentPreviewModel();
        model.document = document;
        model.title = title;
        model.size = size;
        yield this._page.documentPreviewAsync(model);
      }
    });
  }
  static descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._page != null) {
        yield this._page.descriptionAsync(containerId, model);
      }
    });
  }
  static reinitializeContextAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      this._context = null;
      if (this._layout != null) {
        yield this._layout.reloadAsync();
      }
    });
  }
  static registerInitializeCallback(callback) {
    this._initializeCallbacks.push(callback);
  }
  static registerAuthorizeCallback(callback) {
    this._authorizeCallbacks.push(callback);
  }
  /**
   * @returns The current {@link ApplicationContext}, or null if not defined
   *
   * @see getContext
   */
  static findContext() {
    return this._context;
  }
  static get versionId() {
    const context = this.findContext();
    return (context === null || context === void 0 ? void 0 : context.versionId) || null;
  }
  /**
   * @returns The current {@link ApplicationContext}
   * @throws The current {@link ApplicationContext} is not defined
   * @see findContext
   */
  static getContext() {
    if (!this._context) {
      throw Error(`Component helper. Context is not defined.`);
    }
    return this._context;
  }
  /**
   * @returns {@link IUserContext.user} of the current {@link IUserContext}, or null if the current {@link IUserContext} or {@link IUserContext.user} is not defined
   * @see getUser
   */
  static findUser() {
    var _a;
    const context = this.findContext();
    const userContext = context;
    return (userContext === null || userContext === void 0 ? void 0 : userContext.isUserContext) && ((_a = userContext.user) === null || _a === void 0 ? void 0 : _a.username) ? userContext.user : null;
  }
  /**
   * @returns {@link IUserContext.user} of the current {@link IUserContext}
   * @throws The current {@link IUserContext} or its {@link IUserContext.user} is not defined
   * @see findUser
   */
  static getUser() {
    const user = this.findUser();
    if (!user) {
      throw Error(`Component helper. Usercontext or User is not defined.`);
    }
    return user;
  }
  static getUserId() {
    return this.getUser().id;
  }
  static getSessionId() {
    if (this._context) {
      const userContext = this._context;
      if (userContext.isUserContext && userContext.username) {
        return userContext.username.getHashCode().toString();
      }
    }
    return "";
  }
  static getApplicationSessionId() {
    return this._context ? this._context.id : "";
  }
  static setLanguageAsync(language) {
    return __awaiter(this, void 0, void 0, function* () {
      const localizer = ServiceProvider.findLocalizer();
      if (localizer && localizer.setLanguage(language)) {
        yield ch.onOnSetLanguageAsync(language);
        //update context
        if (this._context != null) {
          const newContext = Object.assign({}, this._context);
          newContext.language = language;
          if (this._layout != null) {
            yield this._layout.contextChangedAsync(this._context, newContext);
          }
          this._context = newContext;
        }
      }
    });
  }
  /**
   * Reload the current page.
   */
  static refresh() {
    window.location.reload();
  }
  static reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.findPage();
      if (page) {
        yield page.reRenderAsync();
      }
    });
  }
  /**
   * Gets Xsrf Token
   * @returns XSRF token if it is specified
   */
  static getXsrfToken() {
    return this._context != null ? this._context.xsrfToken : null;
  }
  /**
   * @returns Current {@link ILayoutPage}.
   *
   * @throws {Error} Current {@link ILayoutPage} is not specified.
   */
  static getLayout() {
    if (this._layout == null) throw Error(`Component helper. Layout is not defined.`);
    return this._layout;
  }
  /**
   * @returns Current {@link IBasePage}.
   *
   * @throws {Error} Current {@link IBasePage} is not defined.
   */
  static getPage() {
    if (this._page == null) throw Error(`Component helper. Page is not defined.`);
    return this._page;
  }
  /**
   * @returns Current {@link IBasePage}, or null if not defined.
   */
  static findPage() {
    return this._page;
  }
  static findPageId() {
    return this._page != null ? this._page.id : "";
  }
  static findRouteName() {
    return this._page != null ? this._page.routeName : "";
  }
  static swipeLeftAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.swipeLeftAsync();
      }
    });
  }
  static swipeRightAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._layout != null) {
        yield this._layout.swipeRightAsync();
      }
    });
  }
  static download(file) {
    if (this._layout != null) {
      this._layout.download(file);
    }
  }
  /**
   * Gets unique id
   * @returns id - number
   */
  static getId() {
    return Utility.getId();
  }
  /**
   * Gets component id
   * @returns id - number
   */
  static getComponentId() {
    return Utility.getComponentId();
  }
}
// Fields
ch._initializeCallbacks = [];
ch._authorizeCallbacks = [];
ch._context = null;
ch._layout = null;
ch._page = null;
ch._initialized = false;
ch._debug = false;

/**
 * Page Cache provider
 */
class PageCacheProviderContainer {
  constructor() {
    this.lock = new Mutex();
    this.data = new Dictionary();
  }
}
class PageCacheProvider {
  static clearKeyAsync(container, key) {
    return __awaiter(this, void 0, void 0, function* () {
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        container.data.remove(key);
      }));
    });
  }
  static clear() {
    this._data.data.clear();
  }
  static getAsync(key, action, ttl = 0) {
    return __awaiter(this, void 0, void 0, function* () {
      const hasTtl = ttl > 0;
      const container = hasTtl ? this._dataTtl : this._data;
      key = hasTtl ? key : `${ch.findRouteName()}:${key}`;
      let data = undefined;
      yield container.lock.runExclusive(() => __awaiter(this, void 0, void 0, function* () {
        data = container.data.getValue(key);
        if (data == null) {
          data = yield action();
          container.data.setValue(key, data);
          if (hasTtl) {
            Utility.setTimeout(() => __awaiter(this, void 0, void 0, function* () {
              return yield this.clearKeyAsync(container, key);
            }), ttl);
          }
        }
      }));
      return data;
    });
  }
}
PageCacheProvider._data = new PageCacheProviderContainer();
PageCacheProvider._dataTtl = new PageCacheProviderContainer();

class BasePageDefinitions {
  register(pageName) {
    return __awaiter(this, void 0, void 0, function* () {
      const fullPageName = pageName;
      if (BasePageDefinitions._pages.containsKey(fullPageName)) {
        return BasePageDefinitions._pages.getValue(fullPageName);
      }
      const pageNameItems = pageName.split("/");
      let pageContainer = "";
      if (pageNameItems.length > 1) {
        pageContainer = pageNameItems.slice(0, pageNameItems.length - 1).join("/") + "/";
        pageName = pageNameItems[pageNameItems.length - 1];
      }
      //const module: any = await require(`../pages/${pageContainer}${pageName}/${pageName}`);
      const module = yield this.require(pageContainer, pageName);
      const constructor = module.default;
      BasePageDefinitions._pages.setValue(fullPageName, constructor);
      BasePageDefinitions._modules.setValue(fullPageName, module);
      return constructor;
    });
  }
  constructor() {
    ServiceProvider.addSingleton(this);
  }
  static initialize() {
    // do nothing
  }
  getType() {
    return "IPageDefinitions";
  }
  static getRoutes() {
    var _a;
    return (_a = this.pageRoutesDictionary) !== null && _a !== void 0 ? _a : new Map();
  }
  createPageAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageName = route.name;
      try {
        const pageConstructor = yield this.register(pageName);
        const props = {
          parameters: route.parameters,
          urlParams: route.urlParams,
          routeIndex: route.index,
          routeId: route.id,
          routeName: pageName
        };
        return new pageConstructor(props);
      } catch (e) {
        throw Error(`Unknown route "${pageName}", module or page component cannot be found. ${e}`);
      }
    });
  }
  render(page, ref) {
    const pageName = page.routeName;
    const routeIndex = page.routeIndex;
    const routeId = page.routeId;
    const parameters = page.parameters;
    const urlParams = page.urlParams;
    const parametersHashCode = Utility.getHashCode(parameters);
    const key = `${pageName}:${routeIndex}:${routeId}:${parametersHashCode}`;
    const props = {
      ref: ref,
      key: key,
      parameters: parameters,
      urlParams: urlParams,
      routeIndex: routeIndex,
      routeId: routeId,
      routeName: pageName
    };
    const module = BasePageDefinitions._modules.getValue(pageName);
    // noinspection UnnecessaryLocalVariableJS
    const element = /*#__PURE__*/React.createElement(module.default, props);
    return element;
  }
}
BasePageDefinitions._pages = new Dictionary();
BasePageDefinitions._modules = new Dictionary();
BasePageDefinitions.logoutRouteName = "Logout";
BasePageDefinitions.logoutRoute = new PageRoute(BasePageDefinitions.logoutRouteName);
BasePageDefinitions.dummyRouteName = "Dummy";
BasePageDefinitions.dummyRoute = new PageRoute(BasePageDefinitions.dummyRouteName);
BasePageDefinitions.offlineRouteName = "Offline";
BasePageDefinitions.offlineRoute = new PageRoute(BasePageDefinitions.offlineRouteName);
BasePageDefinitions.errorRouteName = "Error";
BasePageDefinitions.errorRoute = new PageRoute(BasePageDefinitions.errorRouteName);

class PageRouteProvider {
  static initialize() {
    if (!this._initialized) {
      this._initialized = true;
      window.addEventListener("popstate", e => this.onPopStateAsync(e));
    }
  }
  static onPopStateAsync(e) {
    return __awaiter(this, void 0, void 0, function* () {
      this.log('onPopStateAsync: ', e.state);
      const route = e.state || BasePageDefinitions.dummyRoute;
      yield this.invokeRedirectAsync(route, null, true);
    });
  }
  static logoutAsync(layout) {
    return __awaiter(this, void 0, void 0, function* () {
      yield layout.postAsync("/api/Application/Logout", null);
    });
  }
  static onRedirectAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      this.log('onRedirectAsync: ', route);
      try {
        if (!this.sendParametersOnRedirect && !ch.getLayout().useRouting) {
          route.parameters = null;
        }
        yield ApiProvider.postAsync("/api/Application/OnRedirect", route);
      } catch (e) {
        //no additional action needed, not critical
      }
    });
  }
  static onJsErrorAsync(serverError) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield ApiProvider.postAsync("/api/Application/OnJsError", serverError);
      } catch (e) {
        //no additional action needed, not critical
      }
    });
  }
  static invokeRedirectAsync(route, id = null, innerRedirect, replace = false, stopPropagation = false) {
    return __awaiter(this, void 0, void 0, function* () {
      this.initialize();
      this.log('invokeRedirectAsync: ', "\n   route:", route, "\n   id:", id, "\n   innerRedirect", innerRedirect, "\n   replace", replace, "\n   stopPropagation", stopPropagation);
      const context = ch.findContext();
      const currentPage = ch.findPage();
      const layout = ch.getLayout();
      if (!route.id && id) {
        route.id = id;
      }
      const oldRoute = currentPage ? currentPage.route : null;
      PageRoute.normalize(oldRoute);
      PageRoute.normalize(route);
      this.log('before PageRoute.isEqual()', "\n   oldRoute:", oldRoute, "\n   route:", route);
      const routesAreEqual = PageRoute.isEqual(oldRoute, route);
      const newPage = currentPage == null || currentPage.routeName !== route.name || !routesAreEqual;
      this.log("invokeRedirectAsync(1):", "\n   oldRoute:", oldRoute, "\n   replace:", replace, "\n   routesAreEqual:", routesAreEqual, "\n   newPage:", newPage);
      if (newPage) {
        if (route.name === BasePageDefinitions.dummyRouteName) {
          return currentPage;
        }
        if (route.name === BasePageDefinitions.logoutRouteName) {
          yield this.logoutAsync(layout);
          return currentPage;
        }
        let newAlert = null;
        if (currentPage != null) {
          const currentAlert = currentPage.alert;
          const pageDefinitions = ServiceProvider.getRequiredService("IPageDefinitions");
          let canRedirect;
          if (pageDefinitions.canRedirect && pageDefinitions.canRedirect(route) !== null) {
            canRedirect = pageDefinitions.canRedirect(route);
            this.log('Can redirect (pageBase): ', canRedirect);
          } else {
            canRedirect = yield currentPage.beforeRedirectAsync(route, innerRedirect);
            this.log('Can redirect (beforeRedirectAsync): ', canRedirect);
          }
          if (!canRedirect) {
            const currentRoute = currentPage.route;
            this.pushHistoryState(currentRoute, null);
            yield currentPage.reRenderAsync();
            return currentPage;
          }
          // New alert was triggered in method "beforeRedirectAsync";
          if (!AlertModel.isEqual(currentAlert, currentPage.alert)) {
            newAlert = currentPage.alert;
          }
          // Hide current alert
          yield currentPage.hideAlertAsync();
        }
        const page = yield this.createPageAsync(route);
        yield layout.setPageAsync(page);
        // Show new alert
        if (newAlert != null) {
          yield page.alertAsync(newAlert);
        }
        if (context != null) {
          context.currentPage = route;
        }
        this.log("\n   innerRedirect", innerRedirect, "\n   layout.useRouting", layout.useRouting, "\n   routesAreEqual", routesAreEqual);
        if (!innerRedirect) {
          if (!layout.useRouting || !routesAreEqual) {
            replace = replace && window.history.state != null && window.history.length >= 1;
            if (replace) {
              this.replaceHistoryState(route, null);
            } else {
              this.pushHistoryState(route, null);
            }
          }
        }
        document.title = page.getTitle();
        if (route.name !== BasePageDefinitions.errorRouteName) {
          // clear cache
          PageCacheProvider.clear();
          // do not await, just notification event
          // noinspection ES6MissingAwait
          this.onRedirectAsync(route);
        }
        if (stopPropagation) {
          this.stopPropagation();
        }
        this.log('Returning page: ', page);
        return page;
      }
      this.log('Returning currentPage: ', currentPage);
      return currentPage;
    });
  }
  static redirectAsync(route, replace = false, stopPropagation = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield this.invokeRedirectAsync(route, null, false, replace, stopPropagation);
    });
  }
  static createPageAsync(route) {
    return __awaiter(this, void 0, void 0, function* () {
      this.log('createPageAsync: ', route);
      const pageDefinitions = ServiceProvider.getRequiredService("IPageDefinitions");
      return yield pageDefinitions.createPageAsync(route);
    });
  }
  static changeUrlWithoutReload(newPath) {
    return __awaiter(this, void 0, void 0, function* () {
      this.log('changeUrlWithoutReload: ', newPath);
      if (newPath == null) {
        newPath = "/";
      }
      window.history.replaceState(null, "", newPath);
    });
  }
  /**
   * Replace current {@link window.URL} with a localized path, id and parameters from the given {@link PageRoute} without reloading the page.
   * Also replaces the current {@link window.history} entry with the new route.
   * If reloading of the page is wanted, use {@link redirectAsync} instead.
   *
   * @param pageRoute {@link PageRoute} from which to get route name, id and parameters.
   * @param replace If true, replace the current history entry with the new route. If false, add a new history entry.
   */
  static changeUrlWithRouteWithoutReloadAsync(pageRoute, replace = true) {
    return __awaiter(this, void 0, void 0, function* () {
      this.log('changeUrlWithRouteWithoutReloadAsync: ', pageRoute);
      //Hack. Without this invokeRedirectAsync will replaceState before this function and it will mess up history
      //Feel free to make better solution for this :)
      yield new Promise(callback => setTimeout(callback, 2));
      const url = PageRoute.toRelativePath(pageRoute);
      if (replace) {
        window.history.replaceState(pageRoute, "", url);
      } else {
        window.history.pushState(pageRoute, "", url);
      }
    });
  }
  static stopPropagation() {
    throw new Error(AthenaeumConstants.apiError);
  }
  static offline() {
    return __awaiter(this, void 0, void 0, function* () {
      yield PageRouteProvider.redirectAsync(BasePageDefinitions.offlineRoute, true);
    });
  }
  static error(serverError) {
    return __awaiter(this, void 0, void 0, function* () {
      // redirect to error page
      const route = new PageRoute(BasePageDefinitions.errorRouteName);
      route.parameters = {
        error: serverError
      };
      yield PageRouteProvider.redirectAsync(route, true);
    });
  }
  static exception(error, reactInfo = null) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
      if (error && !ApiProvider.isApiError(error)) {
        const page = ch.findPage();
        const pageRouteName = page && page.routeName ? page.routeName : ``;
        const componentStack = reactInfo != null ? (_a = reactInfo.componentStack) !== null && _a !== void 0 ? _a : "" : "";
        const messageHashCode = `${pageRouteName}:${componentStack}:${error.stack}:${error.message}`.getHashCode();
        const stackOverflow = this._lastMessageHashCode == messageHashCode;
        if (stackOverflow) {
          console.warn(error);
          return false;
        }
        this._lastMessageHashCode = messageHashCode;
        const pageName = pageRouteName ? ` on page "${pageRouteName}"` : ``;
        const url = window.location.href;
        const serverError = {
          requestId: "",
          debugDetails: `Unhandled JS exception occured ${pageName} ("${url}"): "${error.message}"\n${error.stack}\n${componentStack}.`
        };
        // do not await, just notification event
        // noinspection ES6MissingAwait
        this.onJsErrorAsync(serverError);
        //redirect to error page
        yield this.error(serverError);
      }
      return true;
    });
  }
  /**
   * Get a {@link PageRoute} registered with the given URL, or null if not found.
   * We try to find a {@link PageRoute} with the full path first. If no match find, remove last url segment and try again until we find a match.
   * First url segment after the {@link PageRoute} name is assigned to {@link PageRoute.id} for backward compatibility.
   * All the other remaining url segments are assigned to {@link PageRoute.urlParams}.
    * @param path URL to resolve to a {@link PageRoute}.
   * @param searchString Optional search string to resolve to {@link PageRoute.parameters}. If no search string is given, the current window.location.search string is used.
   */
  static resolveRoute(path, searchString) {
    var _a;
    this.log('resolveRoute: ', path, searchString);
    const pageDefinitions = ServiceProvider.getService("IPageDefinitions");
    const routes = (_a = pageDefinitions === null || pageDefinitions === void 0 ? void 0 : pageDefinitions.getRoutes) === null || _a === void 0 ? void 0 : _a.call(pageDefinitions);
    if (!routes) {
      return null;
    }
    const parts = path.split("/").filter(route => route !== '');
    for (let pathLength = parts.length; pathLength > 0; pathLength--) {
      const routeSearchPath = parts.slice(0, pathLength).join("/");
      const pageNameKeys = [routeSearchPath, routeSearchPath.toUpperCase(), routeSearchPath.toLowerCase()];
      for (let i = 0; i < pageNameKeys.length; i++) {
        if (routes.containsKey(pageNameKeys[i])) {
          const pageRoute = routes.getValue(pageNameKeys[i]);
          if (parts.length > pathLength) {
            pageRoute.id = parts[pathLength];
            pageRoute.urlParams = parts.slice(pathLength + 1);
          }
          pageRoute.parameters = queryString.parse(searchString !== undefined ? searchString : window.location.search);
          this.log('Found route: ', pageRoute);
          return pageRoute;
        }
      }
    }
    // TODO: through error if no route found?
    this.log('No route found for path: ', path);
    return null;
  }
  static back() {
    window.history.back();
  }
  static forward() {
    window.history.forward();
  }
  static pushHistoryState(route, title = null) {
    this.log('pushHistoryState: ', route, title);
    if (title) {
      document.title = title;
    }
    window.history.pushState(route, title || route.name);
  }
  static replaceHistoryState(route, title = null) {
    this.log('replaceHistoryState: ', route, title);
    if (title) {
      document.title = title;
    }
    window.history.replaceState(route, title || route.name);
  }
  static render(page, ref) {
    const pageDefinitions = ServiceProvider.getRequiredService("IPageDefinitions");
    return pageDefinitions.render(page, ref);
  }
}
PageRouteProvider._initialized = false;
PageRouteProvider._lastMessageHashCode = 0;
/**
 * Should {@link PageRoute.parameters} be sent to API on {@link redirectAsync}.
 * Has no effect if {@link ILayoutPage.useRouting} is true, in which case the parameters are always sent.
 *
 * @default false
 */
PageRouteProvider.sendParametersOnRedirect = false;
PageRouteProvider.log = function (...args) {
  if (ch.debug) {
    console.log("PageRouteProvider: ", ...args);
  }
};

/**
 * API provider
 */
class ApiProvider {
  static invokeLoadingCallbacksAsync(obsolete) {
    return __awaiter(this, void 0, void 0, function* () {
      const isLoading = this.isLoading;
      if (isLoading != obsolete) {
        yield Utility.forEachAsync(this._loadingCallbacks, callback => __awaiter(this, void 0, void 0, function* () {
          return yield callback(isLoading);
        }));
      }
    });
  }
  static get offline() {
    return navigator && !navigator.onLine;
  }
  static setAutoIsSpinningAsync(isSpinning, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._manualSpinning) {
        const isLoading = this.isLoading;
        this._isSpinning += isSpinning ? +1 : -1;
        if (caller) {
          if (caller.hasSpinner()) {
            yield caller.setSpinnerAsync(isSpinning);
          } else {
            const layout = ch.getLayout();
            yield layout.setSpinnerAsync(isSpinning);
          }
        }
        yield this.invokeLoadingCallbacksAsync(isLoading);
      }
    });
  }
  static setManualIsSpinningAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      const isLoading = this.isLoading;
      this._manualSpinning = isSpinning;
      const layout = ch.getLayout();
      yield layout.setSpinnerAsync(isSpinning);
      yield this.invokeLoadingCallbacksAsync(isLoading);
    });
  }
  static setHeaders(httpRequest, setContentType = true) {
    const headers = httpRequest.headers ? new Headers(httpRequest.headers) : new Headers();
    //Content Type
    if (setContentType) {
      headers.set("Content-Type", "application/json");
    }
    //XSRT Token
    const xsrfToken = ch.getXsrfToken();
    if (xsrfToken != null) {
      headers.set("xsrf-token", xsrfToken);
    }
    //Version
    headers.set("renta-version", ch.version);
    httpRequest.credentials = "include";
    httpRequest.headers = headers;
  }
  static ignoreException(endpoint) {
    return endpoint.endsWith("/OnJsError") || endpoint.endsWith("/OnRedirect");
  }
  static fetchAsync(endpoint, httpRequest, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield this.setAutoIsSpinningAsync(true, caller);
        const httpResponse = yield fetch(endpoint, httpRequest);
        const apiResponse = yield this.processServerResponseAsync(httpResponse);
        //const dataResponse: TResponse = ((apiResponse != null) ? apiResponse : {}) as TResponse;
        const dataResponse = apiResponse;
        return dataResponse;
      } catch (error) {
        if (this.offline) {
          yield PageRouteProvider.offline();
        } else {
          const ignore = ApiProvider.isApiError(error) || ApiProvider.ignoreException(endpoint);
          if (!ignore) {
            yield PageRouteProvider.exception(error);
          }
        }
        throw new Error(AthenaeumConstants.apiError);
      } finally {
        yield this.setAutoIsSpinningAsync(false, caller);
      }
    });
  }
  static isAntiForgeryError(httpResponse, jsonResponse) {
    //{ "type": "https://tools.ietf.org/html/rfc7231#section-6.5.1", "title": "Bad Request", "status": 400, "traceId": "0HLLSRLLJPHV2:00000009" }
    return httpResponse.status === AthenaeumConstants.badRequestStatusCode && jsonResponse != null && jsonResponse.title === "Bad Request" && jsonResponse.type === "https://tools.ietf.org/html/rfc7231#section-6.5.1";
  }
  static parseJsonError(jsonResponse) {
    let requestId = "";
    let debugDetails = "";
    if (jsonResponse != null) {
      if (jsonResponse.traceId) {
        requestId = jsonResponse.traceId;
      }
      if (jsonResponse.title) {
        debugDetails = jsonResponse.title + "\n";
      }
      if (jsonResponse.errors && typeof jsonResponse.errors === "object") {
        const errors = jsonResponse.errors;
        for (const propertyName in errors) {
          if (Object.hasOwnProperty.call(errors, propertyName)) {
            const property = errors[propertyName];
            if (property != null && property.length != null) {
              if (typeof property === "string") {
                debugDetails += property + "\n";
              } else {
                debugDetails += property.join("\n");
              }
            }
          }
        }
      }
    }
    const serverError = {
      requestId: requestId,
      debugDetails: debugDetails
    };
    return serverError;
  }
  static processServerResponseAsync(httpResponse) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function* () {
      const textResponse = yield httpResponse.text();
      const endpoint = httpResponse.url;
      if (ApiProvider.ignoreException(endpoint)) {
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.notFoundStatusCode) {
        const serverError = {
          requestId: "",
          debugDetails: `Requested api action not found (404): "${endpoint}".\nServer response:\n${textResponse.trim()}`
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      const hasResponse = textResponse.length > 0;
      const isHtml = hasResponse && (textResponse.startsWith("<!DOCTYPE html>") || textResponse.startsWith("<!doctype html>"));
      if (isHtml) {
        const isMaintenanceOrBlocked = textResponse.indexOf("Support") > 0 || textResponse.indexOf("Site Maintenance") > 0;
        if (isMaintenanceOrBlocked) {
          ch.refresh();
        } else if (!this.offline) {
          const offlineOrRequestIsTooBif = endpoint.endsWith("offline.html") && httpResponse.status == 200;
          const debugDetails = offlineOrRequestIsTooBif ? `Server returned HTML instead of JSON response, probably server is offline or request body is too big.` : `Server returned HTML instead of JSON response, probably requested api action not found.`;
          const serverError = {
            requestId: "",
            debugDetails: debugDetails + `\nEndpoint: "${endpoint}"\nServer response code: "${httpResponse.status}".\nServer response:\n${textResponse.trim()}}`
          };
          yield PageRouteProvider.error(serverError);
        }
        throw new Error(AthenaeumConstants.apiError);
      }
      const jsonResponse = hasResponse ? JSON.parse(textResponse) : null;
      if (httpResponse.status === AthenaeumConstants.unauthorizedStatusCode || ApiProvider.isAntiForgeryError(httpResponse, jsonResponse)) {
        yield ch.reinitializeContextAsync();
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.forbiddenStatusCode) {
        const page = ch.findPage();
        const user = ch.findUser();
        const username = user ? user.username : "unauthorized";
        const source = page ? page.routeName : "unknown";
        const serverError = {
          requestId: "",
          debugDetails: `Access denied.\nSource: "${source}"\nUser: "${username}".\nEndpoint: "${endpoint}".`
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status === AthenaeumConstants.badRequestStatusCode) {
        const serverError = ApiProvider.parseJsonError(jsonResponse);
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (httpResponse.status !== AthenaeumConstants.okStatusCode) {
        const serverError = {
          requestId: "",
          debugDetails: `Endpoint: "${endpoint}"\nServer response status code: "${httpResponse.status}".`
        };
        yield PageRouteProvider.error(serverError);
        throw new Error(AthenaeumConstants.apiError);
      }
      if (jsonResponse != null) {
        const responseContainer = jsonResponse;
        if (responseContainer && responseContainer.isResponseContainer) {
          const value = responseContainer.value;
          if (responseContainer.unauthorized) {
            yield ch.reinitializeContextAsync();
            throw new Error(AthenaeumConstants.apiError);
          }
          if (responseContainer.versionId) {
            const currentVersion = ch.versionId;
            const isNewVersion = currentVersion != null && currentVersion != responseContainer.versionId;
            if (isNewVersion) {
              ch.refresh();
              throw new Error(AthenaeumConstants.apiError);
            }
          }
          if (responseContainer.newVersionAvailable) {
            const context = ch.findContext();
            if (context && context.newVersionInformation) {
              const messageTitle = (_b = (_a = context === null || context === void 0 ? void 0 : context.newVersionInformation) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "New version of application is available";
              const description = (_d = (_c = context === null || context === void 0 ? void 0 : context.newVersionInformation) === null || _c === void 0 ? void 0 : _c.description) !== null && _d !== void 0 ? _d : "";
              const buttonText = (_f = (_e = context === null || context === void 0 ? void 0 : context.newVersionInformation) === null || _e === void 0 ? void 0 : _e.buttonText) !== null && _f !== void 0 ? _f : "Refresh";
              const dialogResult = yield ch.messageBoxAsync(messageTitle, description, {
                okButton: buttonText
              });
              // Just refresh once the dialog is closed in some way. Doesn't matter if they click out of it or close it manually.
              if (dialogResult === DialogResult.OK || dialogResult === DialogResult.None) {
                ch.refresh();
              }
            }
          }
          if (responseContainer.context) {
            yield ch.setContextAsync(responseContainer.context);
          }
          if (responseContainer.error != null) {
            yield PageRouteProvider.error(responseContainer.error);
            throw new Error(AthenaeumConstants.apiError);
          }
          if (responseContainer.redirect) {
            yield PageRouteProvider.redirectAsync(responseContainer.redirect, true);
          }
          if (responseContainer.alert) {
            yield ch.alertAsync(responseContainer.alert);
          }
          if (value != null) {
            Utility.restoreDate(value);
          }
          return value;
        }
      }
      return jsonResponse;
    });
  }
  static invokeWithForcedSpinnerAsync(action, eternal = false) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        yield this.setManualIsSpinningAsync(true);
        const result = yield action();
        if (!eternal) {
          yield this.setManualIsSpinningAsync(false);
        }
        return result;
      } catch (e) {
        yield this.setManualIsSpinningAsync(false);
        throw e;
      }
    });
  }
  static registerIsLoadingCallback(callback) {
    this._loadingCallbacks.push(callback);
  }
  static unRegisterIsLoadingCallback(callback) {
    const index = this._loadingCallbacks.indexOf(callback);
    if (index !== -1) {
      this._loadingCallbacks.splice(index, 1);
    }
  }
  static get isLoading() {
    return this._manualSpinning || this._isSpinning > 0;
  }
  /**
   * Make an HTTP GET-request.
   *
   * @param endpoint Address where to send the GET request.
   * @param caller {@link IBaseComponent} making the GET-request. A spinner will be automatically set to this component,
   *               unless its {@link IBaseComponent.hasSpinner} returns false, in which case the spinner will be set to the current {@link ILayoutPage}.
   */
  static getAsync(endpoint, caller) {
    return __awaiter(this, void 0, void 0, function* () {
      const httpRequest = {
        url: endpoint,
        method: "GET"
      };
      this.setHeaders(httpRequest);
      const response = yield this.fetchAsync(endpoint, httpRequest, caller);
      return response;
    });
  }
  static postFileAsync(endpoint, request = null, caller = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const formData = new FormData();
      formData.append("file", request);
      const httpRequest = {
        url: endpoint,
        body: formData,
        method: "POST"
      };
      this.setHeaders(httpRequest, false);
      const response = yield this.fetchAsync(endpoint, httpRequest, caller);
      return response;
    });
  }
  /**
   * Make an HTTP POST-request.
   *
   * @param endpoint Address where to send the POST request.
   * @param request Body of the POST-request.
   * @param caller {@link IBaseComponent} making the POST-request. A spinner will be automatically set to this component,
   *               unless its {@link IBaseComponent.hasSpinner} returns false, in which case the spinner will be set to the current {@link ILayoutPage}.
   * @param timeout The optional parameter in seconds. 30 secs by default.
   */
  static postAsync(endpoint, request = null, caller = null, timeout = 30) {
    return __awaiter(this, void 0, void 0, function* () {
      request = request != null ? request : {};
      const json = JSON.stringify(request);
      let signal = undefined;
      let timer = undefined;
      if (timeout > 0) {
        const controller = new AbortController();
        signal = controller.signal;
        timer = setTimeout(() => controller.abort(`Request to endpoint ${endpoint} was aborted because timeout of ${timeout} seconds passed`), 1000 * timeout);
      }
      const httpRequest = {
        url: endpoint,
        body: json,
        method: "POST"
      };
      if (signal) {
        httpRequest.signal = signal;
      }
      this.setHeaders(httpRequest);
      try {
        return yield this.fetchAsync(endpoint, httpRequest, caller);
      } finally {
        if (timer) {
          clearTimeout(timer);
        }
      }
    });
  }
  static isApiError(error) {
    return error && (error.name == AthenaeumConstants.apiError || error.message == AthenaeumConstants.apiError);
  }
}
ApiProvider._isSpinning = 0;
ApiProvider._manualSpinning = false;
ApiProvider._loadingCallbacks = [];

var global$1 = global$o;
var fails = fails$n;
var uncurryThis = functionUncurryThis;
var toString = toString$b;
var trim = stringTrim.trim;
var whitespaces = whitespaces$3;

var $parseInt$1 = global$1.parseInt;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $ = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

class JQueryUtility {
  static get $() {
    return this._jQuery || (this._jQuery = window.$ || $$h);
  }
  static getNode(id) {
    return typeof id === "string" ? this.$(`#${id}`) : id;
  }
  static outerWidth(id, includeMargin = true) {
    var _a;
    return (_a = this.getNode(id).outerWidth(includeMargin)) !== null && _a !== void 0 ? _a : 0;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static innerWidth(id) {
    var _a;
    return (_a = this.getNode(id).innerWidth()) !== null && _a !== void 0 ? _a : 0;
  }
  static outerHeight(id, includeMargin = true) {
    var _a;
    return (_a = this.getNode(id).outerHeight(includeMargin)) !== null && _a !== void 0 ? _a : 0;
  }
  static innerHeight(id) {
    var _a;
    return (_a = this.getNode(id).innerHeight()) !== null && _a !== void 0 ? _a : 0;
  }
  static offsetLeft(id, includeMargin = true) {
    var _a, _b;
    const node = this.getNode(id);
    let offsetLeft = (_b = (_a = node.offset()) === null || _a === void 0 ? void 0 : _a.left) !== null && _b !== void 0 ? _b : 0;
    if (includeMargin) {
      const marginLeft = parseInt(node.css("margin-left")) || 0;
      offsetLeft -= marginLeft;
    }
    return offsetLeft;
  }
  static offsetRight(id, includeMargin = true) {
    return JQueryUtility.viewportWidth() - this.offsetLeft(id, includeMargin) - this.outerWidth(id, includeMargin);
  }
  static offsetTop(id, includeMargin) {
    var _a, _b;
    const node = this.getNode(id);
    let offsetTop = (_b = (_a = node.offset()) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : 0;
    if (includeMargin) {
      const marginTop = parseInt(node.css("margin-top")) || 0;
      offsetTop -= marginTop;
    }
    return offsetTop;
  }
  // public static offsetBottom(id: string): number {
  //     return this.documentHeight() - this.offsetTop(id);
  // }
  static positionLeft(id) {
    var _a;
    return (_a = this.getNode(id).position()) === null || _a === void 0 ? void 0 : _a.left;
  }
  static positionRight(id) {
    return this.documentWidth() - this.positionLeft(id);
  }
  static positionTop(id) {
    var _a;
    return (_a = this.getNode(id).position()) === null || _a === void 0 ? void 0 : _a.top;
  }
  static positionBottom(id) {
    return this.documentHeight() - this.positionTop(id);
  }
  static viewportLeft(id) {
    return this.positionLeft(id) - this.viewportScrollLeft();
  }
  static viewportRight(id) {
    return this.viewportWidth() - this.positionLeft(id);
  }
  static viewportTop(id) {
    return this.positionTop(id) - this.viewportScrollTop();
  }
  static viewportBottom(id) {
    return this.viewportHeight() - this.positionTop(id);
  }
  /**
   * Width of the visible part of the screen in pixels
   */
  static viewportWidth() {
    return window.innerWidth;
  }
  /**
   * Height of the visible part of the screen in pixels
   */
  static viewportHeight() {
    return window.innerHeight;
  }
  /**
   * Full width in pixels of the whole document, including the hidden part behind the horizontal scroll.
   */
  static documentWidth() {
    return window.innerWidth;
  }
  /**
   * Full height in pixels of the whole document, including the hidden part behind the vertical scroll.
   */
  static documentHeight() {
    return window.innerHeight;
  }
  static viewportOffsetLeft() {
    return this.viewportScrollLeft();
  }
  static viewportOffsetTop() {
    return this.viewportScrollTop();
  }
  static viewportScrollLeft() {
    var _a;
    return (_a = this.$(document).scrollLeft()) !== null && _a !== void 0 ? _a : 0;
  }
  static viewportScrollTop() {
    var _a;
    return (_a = this.$(document).scrollTop()) !== null && _a !== void 0 ? _a : 0;
  }
}

var DocumentEventType;
(function (DocumentEventType) {
  DocumentEventType[DocumentEventType["Mousedown"] = 0] = "Mousedown";
  DocumentEventType[DocumentEventType["Keydown"] = 1] = "Keydown";
  DocumentEventType[DocumentEventType["Resize"] = 2] = "Resize";
  DocumentEventType[DocumentEventType["Scroll"] = 3] = "Scroll";
  DocumentEventType[DocumentEventType["IsLoading"] = 4] = "IsLoading";
})(DocumentEventType || (DocumentEventType = {}));
class DocumentEventsProvider {
  getContainer(event) {
    switch (event) {
      case DocumentEventType.Mousedown:
        return this._mousedownEvents;
      case DocumentEventType.Keydown:
        return this._keydownEvents;
      case DocumentEventType.Resize:
        return this._resizeEvents;
      case DocumentEventType.Scroll:
        return this._scrollEvents;
      case DocumentEventType.IsLoading:
        return this._isLoadingEvents;
      default:
        throw Error(`DocumentEventsProvider. Unknown document event type "${event}". Container cannot be found.`);
    }
  }
  callAsync(event, e) {
    return __awaiter(this, void 0, void 0, function* () {
      const container = this.getContainer(event);
      const callbacks = container.values();
      const length = callbacks.length;
      for (let i = 0; i < length; i++) {
        try {
          yield callbacks[i](e);
        } catch (_a) {
          // do nothing
        }
      }
    });
  }
  constructor() {
    this._mousedownEvents = new Dictionary();
    this._keydownEvents = new Dictionary();
    this._resizeEvents = new Dictionary();
    this._scrollEvents = new Dictionary();
    this._isLoadingEvents = new Dictionary();
    document.addEventListener("mousedown", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Mousedown, e);
    }), false);
    document.addEventListener("keydown", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Keydown, e);
    }), false);
    window.addEventListener("resize", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Resize, e);
    }), false);
    window.addEventListener("scroll", e => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.Scroll, e);
    }), false);
    //window.addEventListener("offline", async (e) => await ch.alertErrorAsync("You are offline", false, true), false);
    //window.addEventListener("online", async (e) => await ch.flyoutMessageAsync("You are back online"), false);
    ApiProvider.registerIsLoadingCallback(() => __awaiter(this, void 0, void 0, function* () {
      return yield this.callAsync(DocumentEventType.IsLoading, null);
    }));
  }
  register(id, event, callback) {
    const container = this.getContainer(event);
    container.setValue(id, callback);
  }
  unregister(id, event) {
    const container = this.getContainer(event);
    container.remove(id);
  }
}
var DocumentEventsProvider$1 = new DocumentEventsProvider();

/**
 * Base class for all components.
 */
class BaseComponent extends React.Component {
  constructor(props) {
    super(props);
    this._asGlobalClick = this.asGlobalClick();
    this._asGlobalKeydown = this.asGlobalKeydown();
    this._asGlobalResize = this.asGlobalResize();
    this._asGlobalScroll = this.asGlobalScroll();
    this._childComponentIds = new Dictionary();
    this._childComponentRefs = [];
    this._isMounted = false;
    this._isSpinning = false;
    const id = props ? props.id : ch.getComponentId();
    this.id = id != null ? id : ch.getComponentId();
    this.typeName = this.constructor.name;
    ch.register(this);
  }
  asGlobalClick() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalClick === "function") {
      return instance;
    }
    return null;
  }
  asGlobalKeydown() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalKeydown === "function") {
      return instance;
    }
    return null;
  }
  asGlobalResize() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalResize === "function") {
      return instance;
    }
    return null;
  }
  asGlobalScroll() {
    const instance = this;
    if (instance != null && typeof instance.onGlobalScroll === "function") {
      return instance;
    }
    return null;
  }
  clone(element) {
    if (BaseComponent.isComponent(element)) {
      const expandedProps = this.extendChildProps(element);
      const id = element.props.id || ch.getComponentId();
      let ref = element.ref;
      if (ref == null) {
        ref = this._childComponentIds.getValue(id) || null;
        if (ref == null) {
          ref = /*#__PURE__*/React.createRef();
          this._childComponentIds.setValue(id, ref);
        }
      }
      this._childComponentRefs.push(ref);
      const newProps = Object.assign(Object.assign(Object.assign({}, element.props), {
        ref: ref,
        id: id
      }), expandedProps);
      return /*#__PURE__*/React.cloneElement(element, newProps);
    }
    return element;
  }
  isClickedOutsideAsync(e, selector, checkTargetStillExists = false) {
    const target = e.target;
    const container = document.querySelector(selector);
    const outside = container != null && !container.contains(target);
    if (checkTargetStillExists) {
      const targetExists = document.contains(target);
      return targetExists && outside;
    } else {
      return outside;
    }
  }
  /**
   * @return null
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  extendChildProps(element) {
    return null;
  }
  /**
   * @param element Value to check for componentness.
   * @return Is the value a component.
   */
  static isComponent(element) {
    if (element != null) {
      if (element.isComponent !== undefined && typeof element.isComponent === "function" && element.isComponent()) {
        return true;
      }
      let prototype = element.type;
      while (prototype && prototype.name && prototype.name !== Object.name) {
        if (prototype.name === BaseComponent.name) {
          return true;
        }
        prototype = Object.getPrototypeOf(prototype);
      }
    }
    return false;
  }
  /**
   * @return {@link JQueryUtility.$}
   */
  get JQuery() {
    return JQueryUtility.$;
  }
  /**
   * @return The {@link BaseComponent}'s node in DOM as {@link jQuery}.
   */
  getNode() {
    return this.JQuery(`#${this.id}`);
  }
  /**
   * @see ILayoutPage.useRouting
   */
  get useRouting() {
    // noinspection PointlessBooleanExpressionJS - useRouting can be undefined.
    return ch.getLayout().useRouting === true;
  }
  /**
   * @see childrenWithType
   */
  get children() {
    this._childComponentRefs = [];
    let children = this.props.children;
    if (children && children.type && children.type.toString && children.type.toString() === "Symbol(react.fragment)") {
      children = children.props.children;
    }
    const clone = React.Children.map(children, child => {
      const element = child;
      return this.clone(element);
    });
    return clone || [];
  }
  /**
   *  Components have constructor.name but it will get renamed when project is built for production.
   *  With a static constant value on component we can identify which component is in children.
   *  Normally there is one typeName in BaseComponent and it's a instance string value.
   *  But this type extend is for static class value.
   *
   *  @see children
   */
  get childrenWithType() {
    return this.children;
  }
  /**
   * @see ch.mobileApp
   */
  get mobileApp() {
    return ch.mobileApp;
  }
  /**
   * @see ch.isAuthenticated
   */
  get isAuthenticated() {
    return ch.isAuthenticated;
  }
  /**
   * @see ApiProvider.postFileAsync
   */
  postFileAsync(endpoint, file = null) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield ApiProvider.postFileAsync(endpoint, file, this);
    });
  }
  postCacheAsync(endpoint, ttl = 0) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield PageCacheProvider.getAsync(endpoint, () => __awaiter(this, void 0, void 0, function* () {
        return yield this.postAsync(endpoint);
      }), ttl);
    });
  }
  /**
   * Call {@link reRenderAsync} without awaiting.
   */
  reRender() {
    // noinspection JSIgnoredPromiseFromCall
    this.reRenderAsync();
  }
  /**
   * @param id Id of the child {@link IBaseComponent} to find.
   * @return A child {@link IBaseComponent} with the given id, or null if not found.
   */
  findComponent(id) {
    return this.childComponents.find(component => component.id === id);
  }
  /**
   * @see Utility.copyTo
   */
  copyTo(from, ...to) {
    Utility.copyTo(from, ...to);
  }
  /**
   * @see Utility.css
   */
  css(...params) {
    return Utility.css(...params);
  }
  cssIf(className, add, css) {
    const items = className ? className.split(" ") : [];
    const index = items.indexOf(css);
    if (add) {
      if (index === -1) {
        items.push(css);
        return items.join(" ");
      }
    } else {
      if (index !== -1) {
        items.splice(index, 1);
        return items.join(" ");
      }
    }
    return className || "";
  }
  /**
   * @see ReactUtility.toSingleLine
   */
  toSingleLine(text) {
    return ReactUtility.toSingleLine(text);
  }
  /**
   * @see ReactUtility.toMultiLines
   */
  toMultiLines(text) {
    return ReactUtility.toMultiLines(text);
  }
  /**
   * Called by {@link componentWillMount}.
   */
  initializeAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  // IReactComponent
  get isMounted() {
    return this._isMounted;
  }
  /**
   * @deprecated 16.3, use componentDidMount or the constructor instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#initializing-state
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  componentWillMount() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.initializeAsync();
    });
  }
  componentDidMount() {
    return __awaiter(this, void 0, void 0, function* () {
      this._isMounted = true;
      if (this._asGlobalClick) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Mousedown, e => this._asGlobalClick.onGlobalClick(e));
      }
      if (this._asGlobalKeydown) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Keydown, e => this._asGlobalKeydown.onGlobalKeydown(e));
      }
      if (this._asGlobalResize) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Resize, e => this._asGlobalResize.onGlobalResize(e));
      }
      if (this._asGlobalScroll) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.Scroll, e => this._asGlobalScroll.onGlobalScroll(e));
      }
    });
  }
  /**
   * @deprecated 16.3, use static getDerivedStateFromProps instead; will stop working in React 17
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#updating-state-based-on-props
   * @see https://legacy.reactjs.org/blog/2018/03/27/update-on-async-rendering.html#gradual-migration-path
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentWillReceiveProps(nextProps) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  componentWillUnmount() {
    return __awaiter(this, void 0, void 0, function* () {
      this._isMounted = false;
      this._isSpinning = false;
      if (this._asGlobalClick) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Mousedown);
      }
      if (this._asGlobalKeydown) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Keydown);
      }
      if (this._asGlobalResize) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Resize);
      }
      if (this._asGlobalScroll) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.Scroll);
      }
    });
  }
  // ISpinner
  /**
   * @inheritDoc
   *
   * NOTE: Must be overridden to return true in order to enable spinner-related functionalities {@link isSpinning} and {@link setSpinnerAsync} of the {@link BaseComponent}.
   *
   * @return false
   */
  hasSpinner() {
    return false;
  }
  /**
   * @inheritDoc
   *
   * NOTE: Can return true only if {@link hasSpinner} is overridden to return true.
   */
  isSpinning() {
    return this.hasSpinner() && this._isSpinning;
  }
  /**
   * @inheritDoc
   *
   * NOTE: Works only if {@link hasSpinner} is overridden to return true.
   */
  setSpinnerAsync(isSpinning) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.hasSpinner() && isSpinning !== this._isSpinning) {
        this._isSpinning = isSpinning;
        yield this.reRenderAsync();
      }
    });
  }
  // IBaseComponent
  get childComponents() {
    const childComponents = [];
    childComponents.push(...this._childComponentRefs.filter(ref => BaseComponent.isComponent(ref.current)).map(ref => ref.current));
    return childComponents;
  }
  /**
   * @inheritDoc
   * @see ch.desktop
   */
  get desktop() {
    return ch.desktop;
  }
  /**
   * @inheritDoc
   * @see ch.mobile
   */
  get mobile() {
    return ch.mobile;
  }
  /**
   * @inheritDoc
   * @see ch.getPage
   */
  getPage() {
    return ch.getPage();
  }
  /**
   * @inheritDoc
   * @return true
   */
  isComponent() {
    return true;
  }
  outerHeight(includeMargin = true) {
    const node = this.getNode();
    return node.outerHeight(includeMargin) || 0;
  }
  outerWidth(includeMargin = true) {
    const node = this.getNode();
    return node.outerWidth(includeMargin) || 0;
  }
  /**
   * @inheritDoc
   * @see ApiProvider.getAsync
   */
  getAsync(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield ApiProvider.getAsync(endpoint, this);
    });
  }
  /**
   * @inheritDoc
   * @see ApiProvider.postAsync
   */
  postAsync(endpoint, request = null, timeout = 30) {
    return __awaiter(this, void 0, void 0, function* () {
      return yield ApiProvider.postAsync(endpoint, request, this, timeout);
    });
  }
  /**
   * @inheritDoc
   * @see React.Component.forceUpdate
   *
   * NOTE: effective only if the {@link BaseComponent} is mounted.
   */
  reRenderAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted) {
        yield this.forceUpdate();
      }
    });
  }
}

/**
 * Base class for pages.
 */
class BasePage extends BaseComponent {
  asIsLoading() {
    const instance = this;
    if (instance != null && typeof instance.onIsLoading === "function") {
      return instance;
    }
    return null;
  }
  constructor(props = null) {
    super(props || {});
    this._asIsLoading = this.asIsLoading();
  }
  setPageUrlAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const page = this.getPage();
      if (!(page === null || page === void 0 ? void 0 : page.automaticUrlChange) || !this.useRouting) {
        return;
      }
      document.title = page.getTitle();
      yield PageRouteProvider.changeUrlWithRouteWithoutReloadAsync(page.route);
    });
  }
  /**
   * @return User of current {@link IUserContext}.
   * @see ch.getContext
   */
  findUser() {
    return ch.getContext().user || null;
  }
  /**
   * @return Username of current {@link IUserContext}.
   * @see ch.getContext
   */
  get username() {
    return ch.getContext().username || null;
  }
  /**
   * @return Is {@link username} defined.
   */
  get isAuthorized() {
    return !!this.username;
  }
  /**
   * @see ch.flyoutErrorAsync
   */
  static flyoutErrorAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutErrorAsync(message);
    });
  }
  /**
   * @see ch.flyoutMessageAsync
   */
  static flyoutMessageAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutMessageAsync(message);
    });
  }
  /**
   * @see ch.alertWarningAsync
   */
  alertWarningAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertWarningAsync(message, autoClose, flyout);
    });
  }
  /**
   * @see ch.flyoutWarningAsync
   */
  static flyoutWarningAsync(message) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.flyoutWarningAsync(message);
    });
  }
  /**
   * @return ""
   */
  getManual() {
    return "";
  }
  // BaseComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      if (this._asIsLoading) {
        DocumentEventsProvider$1.register(this.id, DocumentEventType.IsLoading, () => __awaiter(this, void 0, void 0, function* () {
          return yield this._asIsLoading.onIsLoading();
        }));
      }
      yield this.setPageUrlAsync();
    });
  }
  componentWillUnmount() {
    const _super = Object.create(null, {
      componentWillUnmount: {
        get: () => super.componentWillUnmount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      if (this._asIsLoading) {
        DocumentEventsProvider$1.unregister(this.id, DocumentEventType.IsLoading);
      }
      yield _super.componentWillUnmount.call(this);
    });
  }
  // IBasePage
  /**
   * @inheritDoc
   *
   * Does nothing and returns.
   * @return true
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onSwipeHandlerAsync(direction) {
    return __awaiter(this, void 0, void 0, function* () {
      return true;
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertAsync
   */
  alertAsync(alert) {
    return __awaiter(this, void 0, void 0, function* () {
      yield ch.alertAsync(alert);
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertErrorAsync
   */
  alertErrorAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertErrorAsync(message, autoClose, flyout);
    });
  }
  /**
   * @inheritDoc
   * @see ch.alertMessageAsync
   */
  alertMessageAsync(message, autoClose = false, flyout = false) {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.alertMessageAsync(message, autoClose, flyout);
    });
  }
  /**
   * @inheritDoc
   * @see ch.hideAlertAsync
   */
  hideAlertAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      return ch.hideAlertAsync();
    });
  }
  /**
   * @inheritDoc
   * @see IPageContainer.confirmAsync
   */
  confirmAsync(title) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      return pageContainer != null && (yield pageContainer.confirmAsync(title));
    });
  }
  messageBoxAsync(titleOrModel, caption, buttons, icon) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      return pageContainer != null ? yield pageContainer.messageBoxAsync(titleOrModel, caption, buttons, icon) : DialogResult.None;
    });
  }
  documentPreviewAsync(model) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        yield pageContainer.documentPreviewAsync(model);
      }
    });
  }
  descriptionAsync(containerId, model) {
    return __awaiter(this, void 0, void 0, function* () {
      const pageContainer = ServiceProvider.getService("IPageContainer");
      if (pageContainer != null) {
        yield pageContainer.descriptionAsync(containerId, model);
      }
    });
  }
  /**
   * @inheritDoc
   *
   * Does nothing and returns.
   * @return true
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  beforeRedirectAsync(nextRoute, innerRedirect) {
    return __awaiter(this, void 0, void 0, function* () {
      return true;
    });
  }
  /**
   * @inheritDoc
   * @see ch.getLayout
   */
  getLayout() {
    return ch.getLayout();
  }
  getTitle() {
    const titleLocalizationItem = `${this.routeName}Page.Title`;
    const localizer = ServiceProvider.findLocalizer();
    return localizer != null && localizer.contains(titleLocalizationItem) ? localizer.get(titleLocalizationItem) : this.routeName;
  }
  /**
   * @inheritDoc
   * @see ch.getContext
   */
  getContext() {
    return ch.getContext();
  }
  getManualProps() {
    return {
      manual: this.getManual()
    };
  }
  /**
   * @inheritDoc
   * @return true
   */
  isPage() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide top navigation menu.
   * @return true
   */
  get hasTopNav() {
    return true;
  }
  /**
   * @inheritDoc
   * Can be overridden in a page class to show/hide left navigation menu.
   * @return true
   */
  get hasLeftNav() {
    return true;
  }
  /**
   * @inheritDoc
   * @return true
   */
  get hasFooter() {
    return true;
  }
  /**
   * {@link ch.alert}
   */
  get alert() {
    return ch.alert;
  }
  get routeName() {
    return this.props.routeName;
  }
  get routeIndex() {
    return this.props.routeIndex != null ? this.props.routeIndex : null;
  }
  get routeId() {
    return this.props.routeId != null ? this.props.routeId : null;
  }
  get parameters() {
    return this.props.parameters || null;
  }
  get urlParams() {
    return this.props.urlParams || null;
  }
  get route() {
    var _a;
    return new PageRoute(this.routeName, this.routeIndex, this.routeId, Object.assign({}, this.parameters), [...((_a = this.urlParams) !== null && _a !== void 0 ? _a : [])]);
  }
  get automaticUrlChange() {
    return !!this.props.automaticUrlChange;
  }
}

/**
 * Base class for all asynchronous components.
 */
class BaseAsyncComponent extends BaseComponent {
  constructor(props) {
    var _a;
    super(props);
    this._isAsync = (_a = props ? props.isAsync : null) !== null && _a !== void 0 ? _a : true;
  }
  /**
   * Fetch data via HTTP GET from the endpoint specified in {@link getEndpoint}.
   * @return Data returned by the endpoint.
   */
  fetchDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      const endpoint = this.getEndpoint();
      return yield this.getAsync(endpoint);
    });
  }
  /**
   * Reload the {@link BaseAsyncComponent}'s data if it is not already loaded or loading.
   * @param reload Should reload be forced if the data is already loaded.
   */
  invokeReloadDataAsync(reload = false) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isMounted && this.isAsync() && !this.isLoading && this.canReload()) {
        try {
          let state = this.state;
          if (reload || state.data == null) {
            state.isLoading = true;
            yield this.setState(state);
            const data = yield this.fetchDataAsync();
            state = this.state;
            state.data = data;
            yield this.processDataAsync(state, data);
            state.isLoading = false;
            if (this.isMounted) {
              yield this.setState(state);
            }
          }
        } catch (e) {
          if (this.isMounted) {
            yield this.setState({
              isLoading: false
            });
          }
          yield PageRouteProvider.exception(e);
        }
      }
    });
  }
  /**
   * Does nothing.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  processDataAsync(state, data) {
    return __awaiter(this, void 0, void 0, function* () {
      // do nothing
    });
  }
  /**
   * Does the {@link BaseAsyncComponent} have asynchronously loaded data.
   */
  get hasData() {
    return this.state.data != null;
  }
  /**
   * Can the {@link BaseAsyncComponent} be reloaded.
   * @return true
   */
  canReload() {
    return true;
  }
  /**
   * Call {@link reloadAsync} without awaiting.
   */
  reload() {
    // reload without await
    // noinspection JSIgnoredPromiseFromCall
    this.invokeReloadDataAsync(true);
  }
  // BaseComponent
  componentDidMount() {
    const _super = Object.create(null, {
      componentDidMount: {
        get: () => super.componentDidMount
      }
    });
    return __awaiter(this, void 0, void 0, function* () {
      yield _super.componentDidMount.call(this);
      yield this.invokeReloadDataAsync();
    });
  }
  /**
   * @inheritDoc
   *
   * NOTE: Can return true only if {@link hasSpinner} is overridden to return true.
   */
  isSpinning() {
    return this.hasSpinner() && (this.isLoading || super.isSpinning());
  }
  // IAsyncComponent
  isAsync() {
    return this._isAsync && this.getEndpoint().length > 0;
  }
  reloadAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.invokeReloadDataAsync(true);
    });
  }
  get isLoading() {
    return this.state.isLoading;
  }
}

class StylesUtility {
  static textAlign(value) {
    switch (value) {
      case TextAlign.Left:
        return "left";
      case TextAlign.Center:
        return "center";
      case TextAlign.Right:
        return "right";
      default:
        return "initial";
    }
  }
  static verticalAlign(value) {
    switch (value) {
      case VerticalAlign.Top:
        return "top";
      case VerticalAlign.Middle:
        return "middle";
      case VerticalAlign.Bottom:
        return "bottom";
      default:
        return "initial";
    }
  }
}

var DataStorageType;
(function (DataStorageType) {
  DataStorageType[DataStorageType["Session"] = 0] = "Session";
  DataStorageType[DataStorageType["Page"] = 1] = "Page";
  DataStorageType[DataStorageType["Route"] = 2] = "Route";
})(DataStorageType || (DataStorageType = {}));
class UserInteractionDataStorage {
  constructor() {
    this._data = new Dictionary();
    this._initialized = false;
    this._key = null;
  }
  get key() {
    if (this._key !== null && this._key !== undefined) {
      return this._key;
    }
    const context = ch.findContext();
    const applicationName = context ? context.applicationName : null;
    if (!applicationName) {
      return `${window.location.host}.userInteractionDataStorage`;
    }
    const sessionId = ch.getSessionId();
    this._key = `${applicationName}.${sessionId}.userInteractionDataStorage`;
    return this._key;
  }
  get data() {
    this.initialize();
    return this._data;
  }
  initialize() {
    if (!this._initialized) {
      this._initialized = true;
      if (window.localStorage) {
        const json = window.localStorage.getItem(this.key);
        if (json) {
          const data = JSON.parse(json);
          const destination = this._data;
          destination.table = data.table;
          destination.nElements = data.nElements;
        }
      } else {
        console.error('LocalStorage is not available during initialization.');
      }
    }
  }
  save() {
    if (window.localStorage) {
      const json = JSON.stringify(this.data);
      window.localStorage.setItem(this.key, json);
    } else {
      console.error('LocalStorage is not available during save.');
    }
  }
  getKey(type, id) {
    const page = ch.findPage();
    return page === null || type === DataStorageType.Session ? id : type === DataStorageType.Route ? `${page.routeName}:${page.routeIndex}:${page.routeId}:${id}` : `${page.routeName}:${id}`;
  }
  set(id, value, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    this.data.setValue(key, value);
    this.save();
  }
  get(id, defaultValue = null, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    return this.data.getValue(key) || defaultValue;
  }
  restore(id, to, type = DataStorageType.Page) {
    const key = this.getKey(type, id);
    const value = this.data.getValue(key);
    if (value != null && to != null) {
      Utility.copyTo(value, to);
    }
    return to;
  }
  clear() {
    this.data.clear();
    this.save();
  }
  onAuthorize() {
    return __awaiter(this, void 0, void 0, function* () {
      this._initialized = false;
      this._key = null;
    });
  }
}
var UserInteractionDataStorage$1 = new UserInteractionDataStorage();

class BaseComponentsLocalizer extends BaseLocalizer {
  constructor(supportedLanguages, language) {
    super(supportedLanguages, language);
  }
  getType() {
    return "IComponentsLocalizer";
  }
}
class BaseComponentLocalizer extends BaseLocalizer {
  constructor(supportedLanguages, language) {
    super(supportedLanguages, language);
    //private readonly _component: IBaseComponent;
    this._allSupportedLanguages = null;
    this._browserLanguageCode = null;
    this._applicationLocalizer = null;
    this._componentsLocalizer = null;
  }
  getApplicationLocalizer() {
    return this._applicationLocalizer || (this._applicationLocalizer = ServiceProvider.getService("ILocalizer"));
  }
  getComponentsLocalizer() {
    return this._componentsLocalizer || (this._componentsLocalizer = ServiceProvider.getService("IComponentsLocalizer"));
  }
  getSupportedLanguages() {
    if (this._allSupportedLanguages) {
      return this._allSupportedLanguages;
    }
    const applicationLocalizer = this.getApplicationLocalizer();
    this._allSupportedLanguages = applicationLocalizer ? applicationLocalizer.supportedLanguages : super.getSupportedLanguages();
    return this._allSupportedLanguages;
  }
  getLanguage() {
    // Fetch language from application localizer
    const applicationLocalizer = this.getApplicationLocalizer();
    if (applicationLocalizer != null) {
      return applicationLocalizer.language;
    }
    return this.browserLanguageCode || this.getDefaultLanguage();
  }
  get browserLanguageCode() {
    if (this._browserLanguageCode) {
      return this._browserLanguageCode;
    }
    const code = window.navigator.language.toLowerCase();
    const supportedLanguages = this.getSupportedLanguages();
    const supportedLanguage = supportedLanguages.find(item => item.code.toLowerCase() === code || item.label.toLowerCase() === code) || null;
    this._browserLanguageCode = supportedLanguage ? supportedLanguage.code : null;
    return this._browserLanguageCode;
  }
  getType() {
    return this.constructor.name;
  }
  get language() {
    return this.getLanguage();
  }
  getValue(language, name, ...params) {
    const applicationLocalizer = this.getApplicationLocalizer();
    if (applicationLocalizer != null && applicationLocalizer.contains(name)) {
      return applicationLocalizer.getValue(language, name, ...params);
    }
    const componentsLocalizer = this.getComponentsLocalizer();
    if (componentsLocalizer && componentsLocalizer.contains(name)) {
      return componentsLocalizer.getValue(language, name, ...params);
    }
    return super.getValue(language, name, ...params);
  }
  contains(name) {
    return super.contains(name);
  }
}

export { ActionType, AlertModel, AlertType, Align, ApiProvider, ApplicationContext, ArrayScope, BaseAsyncComponent, BaseComponent, BaseComponentLocalizer, BaseComponentsLocalizer, BaseInputType, BasePage, BasePageDefinitions, BasePageParameters, ch as ComponentHelper, CountryInfo, DataStorageType, DescriptionModel, DialogResult, DocumentEventType, DocumentEventsProvider$1 as DocumentEventsProvider, DocumentPreviewModel, DocumentPreviewSize, EnvironmentCountry, EnvironmentCountryHelper, InputValidationRule, JQueryUtility, Justify, LinkTarget, MessageBoxButtons, MessageBoxIcon, PageCacheProvider, PageRoute, PageRouteProvider, PasswordValidationError, PasswordValidationRule, ReactUtility, ServerError, StylesUtility, SwipeDirection, TabBadgeShape, TextAlign, UserInteractionDataStorage$1 as UserInteractionDataStorage, VerticalAlign, WebApplicationType, ch };
